import React, {Component} from 'react';
import AppDev from "../assets/images/competitions/techy/App_Dev.jpg";
import Arcesium from "../assets/images/logos/arcesium.jpg";
import CodingNinjas from "../assets/images/logos/codingn.jpg";
import CADPro from "../assets/images/competitions/techy/CAD_PRO.png";
import Enigma from "../assets/images/competitions/techy/enigma.png";
import CircuitBuilding from "../assets/images/competitions/techy/circuit_building.jpg";
import ArduinoCoding from "../assets/images/competitions/techy/code_arduino.jpg";
import WebDev from "../assets/images/competitions/techy/web_development.jpeg";
import Proquest from "../assets/images/competitions/techy/proquest.png";
import Machina from "../assets/images/competitions/techy/machina_doctrina.png";
import DeepN from "../assets/images/competitions/techy/deepn.png";
import PaperPresentation from "../assets/images/competitions/techy/paper_presentation.jpg";
import Hackathon from "../assets/images/competitions/techy/hackathon.jpeg";
import SharkTank from "../assets/images/competitions/techy/sharktank.jpeg";
import ArtAttack from "../assets/images/competitions/culty/art.PNG";
import Breakfree from "../assets/images/competitions/culty/breakfree.png";
import SBI from "../assets/images/logos/SBI.png";
import CampusIdol from "../assets/images/competitions/culty/Campus_idol.jpeg";
import UnionBank from "../assets/images/logos/unionb.png";
import Chromatics from "../assets/images/logos/chromatics.jpg";
import DoodleArt from "../assets/images/competitions/culty/doodle.png";
import FilmfareFiesta from "../assets/images/competitions/culty/filmfare fiesta.jpg";
import TalingTimber from "../assets/images/logos/talkingTimber.jpg";
import Glitz from "../assets/images/competitions/culty/Campus princess.JPG";
import Nrityanjali from "../assets/images/competitions/culty/Classical Dance.PNG";
import LIC from "../assets/images/logos/LIC.png";
import Picelectric from "../assets/images/competitions/culty/picelectic.jpg";
import Standup from "../assets/images/competitions/culty/standup.JPG";
import PlotTwist from "../assets/images/competitions/culty/Plot the Twist.jpg";
import InkedVerse from "../assets/images/competitions/culty/InkedVerses_final.jpg";
import TLT from "../assets/images/competitions/culty/two line terror.jpg";
import JustKidding from "../assets/images/competitions/culty/Just Kidding_final_2.jpg";
import MyHearthrob from "../assets/images/competitions/culty/heartthrob.png";

import '../assets/styles/schedule.scss';
import {Image, Placeholder} from "semantic-ui-react";
import One from "../assets/images/competitions/infi/Mr and Ms Elan.jpg";
import Two from "../assets/images/competitions/infi/Best pick up line.jpg";
import Three from "../assets/images/competitions/infi/Chess.jpg";
import Four from "../assets/images/competitions/infi/Valorant.jpg";
import Five from "../assets/images/competitions/infi/meme.png";
import Six from "../assets/images/competitions/infi/Quiz.png";
import ZakirKhan from "../assets/images/competitions/proshows/zakir.jpeg";
import SuhaniShah from "../assets/images/competitions/proshows/suhani_shah.jpeg";
import Shriya from "../assets/images/competitions/proshows/shriya.jpeg";
import Nalayak from "../assets/images/competitions/proshows/nalayak.jpeg";
import HB1 from '../assets/images/competitions/Webinar_Ranganathan.jpg';
import HB2 from '../assets/images/competitions/Webinar_George.jpg';
import HB3 from '../assets/images/competitions/Webinar_Venkatesh.jpg';
import HB4 from '../assets/images/competitions/Webinar_Srikanth.jpg';
import Yocket from '../assets/images/competitions/yocket.jpeg';


function getContent(type,content) {
    if(type==='text'){
        return <p className={'text'}>{content}</p>
    }else if(type==='list'){
        return <ul>
            {
                content.map(item=>{
                    return (<li>{item}</li>)
                })
            }
        </ul>
    }else if(type==='table'){
        return <table>
            {content.left.map((item,index)=>{
                return <tr>
                    <td>{content.left[index]}</td>
                    <td>{content.right[index]}</td>
                </tr>
            })}
        </table>
    }else if(type==='contact'){
        return <div className={'contact-div'}>
            {content.map(item=>{
                return (<div>
                    <p>{item.name}</p>
                    <p>{item.mobile}</p>
                </div>)
            })}
        </div>
    }
}

class EventDetails extends Component {

    constructor() {
        super();
        //const imgRef = React.createRef(null);
        // this.state={
        //     loaded:false
        // }
        this.data = [
            {
                name:'App Development ',
                photo:AppDev,
                platformIndependent:true,
                details:"This competition challenges participants to create innovative applications on mobile platforms - Android, iOS and Windows Phone. Grab the chance to Influence with creativity and innovation by designing a peculiar app.\n",
                rules:'https://drive.google.com/file/d/1CZJwuIZPxCmRJGtqUnC7lebIVAoBfdJf/view',
                //submit:'',
                modal: {
                    sp1:Arcesium ,
                    sp2:CodingNinjas,
                    name:'App Development',
                    link:'https://www.airmeet.com/e/f182b3e0-81c4-11eb-a566-9ddd61121691',
                    data: [
                        {
                            name:"Introduction",
                            type:'text',
                            content:'Elan & ηvision 2021, IIT Hyderabad proudly\n' +
                                '\n' +
                                'presents its app development hackathon. An event that challenges\n' +
                                'participants to create innovative applications on mobile platforms. It is a\n' +
                                'three days competition, so grab the chance to influence with creativity and\n' +
                                'innovation by designing a peculiar app during ELAN & ηvision 2021.'
                        },
                        {
                            name:"STRUCTURE:",
                            type:'text',
                            content:'The hackathon will last for a total of 72 hours. Winners are decided in 48'+
                                'hours after the hackathon.'
                        },
                        {
                            name:"TIMELINE:",
                            type:'table',
                            content:{
                                left:[
                                    'Registration Start Date',
                                    'Registration End Date',
                                    'Event Time',
                                    'Winner Announcement',
                                ],
                                right:[
                                    '13/02/2021',
                                    '10/03/2021',
                                    '11/03/2021 5pm to 14/03/2021 5pm',
                                    '17/03/2021',
                                ]
                            }
                        },
                        {
                            name:"PROBLEM STATEMENT:",
                            type:'text',
                            content:'Participants are required to create an app'+
                                'based on the theme i.e given at the start of hackathon.'
                        },
                        {
                            name:"JUDGING CRITERIA:",
                            type:'table',
                            content:{
                                left:[
                                    'Features',
                                    'Reliability',
                                    'Technical Difficulty',
                                    'User Experience',
                                    'Presentation',
                                    'Code Quality',
                                ],
                                right:[
                                    '30%',
                                    '20%',
                                    '20%',
                                    '10%',
                                    '10%',
                                    '10%',
                                ]
                            }
                        },
                        {
                            name:"SUBMISSION FORMAT:",
                            type:'list',
                            content:[
                                'Before the end of the stipulated 72 hours, teams are required to\n' +
                                'submit their code in a private Github repository shared with a limited\n' +
                                'number of Github IDs.',
                                'All the teams should also submit pre-built release versions of their\n' +
                                'applications for all major platforms that clients may use. Example:\n' +
                                'Pre-built post-Lollipop APKs for Android.',
                                'The submission Github repository should contain a README.md with\n' +
                                'detailed instructions on how to build all your software on a Linux\n' +
                                'machine running Ubuntu 18.04/20.04 LTS.',

                            ]
                        },
                        {
                            name:"EVENT RULES:",
                            type:'list',
                            content:[
                                'Teams should not use any proprietary library in their code. All\n' +
                                'APIs/SDKs/Libraries used in the development of your project should\n' +
                                'be open-source.',
                                'A team can submit only one entry for the contest. Participation in the\n' +
                                'event is subjected on a “per-team” basis meaning you are not allowed\n' +
                                'to be on more than one teams at the event.',
                                'Any intellectual property developed during and within the scope of the\n' +
                                'hackathon must be open source and licensed under one of the\n' +
                                'licenses referenced in Open Source licenses & Standards.',
                                'Teams are also required to give an interactive demonstration of the\n' +
                                'project to a panel of judges, who might ask questions specific to\n' +
                                'either the implementation or usability of your project.',
                                'Teams can have a maximum of 4 participants.',
                                'All decisions taken by the organisers and judges will be final and\n' +
                                'binding.',

                            ]
                        },
                        {
                            name:"REGISTRATION DETAILS:",
                            type:'text',
                            content:'Each participant has to register for the event by filling their details in the\n' +
                                'registration form available on the Elan and Nvision 2021 Website\n' +
                                '(https://elan.org.in/competitions)'
                        },
                        {
                            name:"CERTIFICATES AND PRIZES::",
                            type:'list',
                            content:[
                                'The top two teams will receive prizes of worth Rs. 20,000.',
                                'This prize money will be awarded via NEFT and will be processed within 30\n' +
                                'working days.',
                                'The winner will be notified via email sent from(elan@iith.ac.in).',
                                'E-certificate of Participation will be given to all the participants who have\n' +
                                'submitted their model via submission form',
                                'E-certificate of Excellence will be given to the top 2 teams.',
                            ]
                        },
                        {
                            name:"CONTACT DETAILS:",
                            type:'contact',
                            content:[
                                {
                                    name:'Organiser Name: K. Praneeth Nayak',
                                    mobile:'Mobile Number: 9121663809'
                                },
                                {
                                    name:'Organiser Name: Vikhyath',
                                    mobile:'Mobile Number: 7708711549'
                                },
                            ]
                        },

                    ]
                },

            },//0
            {
                name:'CAD Pro',
                photo:CADPro,
                platformIndependent:true,
                details:"Contrive a way to outsmart your opponents in designing a CAD model.An on-the-spot designing round to show off your expertise in designing.\n",
                rules:'https://drive.google.com/file/d/1G5TMXoHyK1QEEB-d1HTpBwH_m7qI2VoS/view',
                //submit:'',
                modal: {
                    sp1:Arcesium ,
                    name:'CAD Pro',
                    data: [
                        {
                            name:"Introduction",
                            type:'text',
                            content:'Elan & ηvision 2021, IIT Hyderabad proudly presents its 3D model designing event "CAD PRO". Contrive a way to outsmart your opponents in designing a CAD model. It is an on-the-spot designing round to show off your expertise in designing during ELAN & ηvision 2021.\n'
                        },
                        {
                            name:"STRUCTURE:",
                            type:'text',
                            content:'A single stage on-the-spot contest, held on the fest day itself. Winners are decided straight after the single round.'
                        },
                        {
                            name:"TIMELINE:",
                            type:'table',
                            content:{
                                left:[
                                    'Registration Start Date',
                                    'Registration End Date',
                                    'Event Time',
                                    'Winner Announcement',
                                ],
                                right:[
                                    '13/02/2021',
                                    '10/03/2021',
                                    '15:00 to 18:00 on 13/03/2021',
                                    '14/03/2021',
                                ]
                            }
                        },
                        {
                            name:"PROBLEM STATEMENT:",
                            type:'list',
                            content:[
                                ' It will be an on-spot designing round. Participants will be given a problem statement at the time of event and they have to submit their design in the specified time limit (3 hours)',
                                'Each specification will carry some points according to the question and its level of difficulty.',
                                'Models can be prepared in any CAD software (CATIA/ ProE/ AutoCad/ Solidworks/ Solidedge).\n',
                                'Participants need to submit the final .stl or IGES or STEP file created from above softwares.',
                                'Participant’s must necessarily install softwares in their laptop’s before participating in the event.\n',
                            ]
                        },
                        {
                            name:"JUDGING CRITERIA:",
                            type:'list',
                            content:[
                                'Any sign of plagiarism from the internet or from other participants will lead to direct disqualification.',
                                'Participants can only submit once. In case of multiple submissions only the first entry will be considered for evaluation.',
                                'The design will be evaluated on the following aspects:\n' +
                                'Originality of the Design\n' +
                                'Clear and easily comprehensible design\n' +
                                'Time Taken (max 3 hrs)\n',
                                'Certificate of Merit and Prizes will be given for the top two teams.',
                                'Participation Certificate will be given for those who registered online and participated in the event.',
                                'Participation Certificates will not be given to the participants who are not present at the time of event',
                                'Disqualified teams will also not be considered for any certificates',
                            ]
                        },
                        {
                            name:"SUBMISSION FORMAT:",
                            type:'text',
                            content:
                                'Each team has to upload their model in the above specified format in the submission form available in the website during the event. '

                        },
                        {
                            name:"EVENT RULES:",
                            type:'list',
                            content:[
                                'Each team can have a maximum of two participants.',
                                'There will be a prelim round in case the participation exceeds',
                                'Decisions of the organizers will be final and binding. No claim will be entertained against the announced results.',

                            ]
                        },
                        {
                            name:"REGISTRATION DETAILS:",
                            type:'text',
                            content:'Each participant has to register for the event by filling their details in the\n' +
                                'registration form available on the Elan and Nvision 2021 Website\n' +
                                '(https://elan.org.in/competitions)'
                        },
                        {
                            name:"CERTIFICATES AND PRIZES::",
                            type:'list',
                            content:[
                                'The top two teams will receive prizes of worth Rs. 8,000.',
                                'This prize money will be awarded via NEFT and will be processed within 30\n' +
                                'working days.',
                                'The winner will be notified via email sent from(elan@iith.ac.in).',
                                'E-certificate of Participation will be given to all the participants who have\n' +
                                'submitted their model via submission form',
                                'E-certificate of Excellence will be given to the top 2 teams.',
                            ]
                        },
                        {
                            name:"CONTACT DETAILS:",
                            type:'contact',
                            content:[
                                {
                                    name:'Organiser Name:  Sai Sravya',
                                    mobile:'Mobile Number: 9182740127 '
                                },
                                {
                                    name:'Organiser Name: Poorvika ',
                                    mobile:'Mobile Number: 9900810774'
                                },
                            ]
                        },

                    ]
                },
            },
            {
                name:'Enigma',
                photo:Enigma,
                platformIndependent:true,
                details:"Find the mysterious secret techniques to decrypt the given texts/messages. Clear all the levels in the allotted time to become the ultimate \"cryptacker\". It's a pen and paper event. Each team has to decode a series of crypted messages.",
                rules:'https://drive.google.com/file/d/1WDyji62CuitkguERfaBSZtk5Ni4EnFdV/view',
                //submit:'',
                modal: {
                    sp1:Arcesium ,
                    sp2:CodingNinjas,
                    name:'Enigma',
                    data: [
                        {
                            name:"Introduction",
                            type:'text',
                            content:'Elan & ηvision 2021, IIT Hyderabad proudly presents “Enigma". Find the mysterious secret techniques to decrypt the given texts/messages. Clear all the levels in the allotted time to become the ultimate “cryptacker”.'
                        },
                        {
                            name:"STRUCTURE:",
                            type:'text',
                            content:'A single stage on-the-spot contest, held during the fest  itself. Winners are decided straight after the evaluation of this single round.'
                        },
                        {
                            name:"TIMELINE:",
                            type:'table',
                            content:{
                                left:[
                                    'Registration Start Date',
                                    'Registration End Date',
                                    'Event Time',
                                    'Winner Announcement',
                                ],
                                right:[
                                    '13/02/2021',
                                    '10/03/2021',
                                    '9:00 to 11:00 on 14/03/2021',
                                    '14/03/2021',
                                ]
                            }
                        },
                        {
                            name:"PROBLEM STATEMENT:",
                            type:'text',
                            content:'Each team has to decode a series of crypted messages'
                        },
                        {
                            name:"JUDGING CRITERIA:",
                            type:'list',
                            content:[
                                'Max Team size - 2(Individual participants are welcome)',
                                'There are points associated with each message and the team to accumulate the maximum number of points wins. Tie breakers would be conducted if necessary.',
                                'Decisions of the organizers will be final and binding. No claim will be entertained against the announced results.',
                            ]
                        },
                        // {
                        //     name:"SUBMISSION FORMAT:",
                        //     type:'text',
                        //     content:'Each team has to upload the files in the above specified format in the submission form available in the website during the event.'
                        // },
                        {
                            name:"EVENT RULES:",
                            type:'list',
                            content:[
                                'Participants can be an individual or a team of 2.'

                            ]
                        },
                        {
                            name:"REGISTRATION DETAILS:",
                            type:'text',
                            content:'Each participant has to register for the event by filling their details in the\n' +
                                'registration form available on the Elan and Nvision 2021 Website\n' +
                                '(https://elan.org.in/competitions)'
                        },
                        {
                            name:"CERTIFICATES AND PRIZES::",
                            type:'list',
                            content:[
                                'The top two teams will receive prizes of worth Rs. 8,000.',
                                'This prize money will be awarded via NEFT and will be processed within 30\n' +
                                'working days.',
                                'The winner will be notified via email sent from(elan@iith.ac.in).',
                                'E-certificate of Participation will be given to all the participants who have\n' +
                                'submitted their model via submission form',
                                'E-certificate of Excellence will be given to the top 2 teams.',
                            ]
                        },
                        {
                            name:"CONTACT DETAILS:",
                            type:'contact',
                            content:[
                                {
                                    name:'Organiser Name:  Ruthwika Boyapally',
                                    mobile:'Mobile Number: 9182734726 '
                                },
                                {
                                    name:'Organiser Name:  Dhruv Srikanth',
                                    mobile:'Mobile Number: 9740530030'
                                },
                            ]
                        },

                    ]
                },
            },
            {
                name:'Circuit Building',
                photo:CircuitBuilding,
                platformIndependent:true,
                details:"The aim of this competition is to judge the problem solving skills and understanding of the basic circuit designing concepts of the students. Each team has to build a circuit as per the requirement keeping in mind the efficiency factor.",
                rules:'https://drive.google.com/file/d/1Zpte-06w7JVjV42ltaGePbaSIVw04geg/view',
                //submit:'',
                modal: {
                    sp1:Arcesium ,
                    name:'Circuit Building',
                    link:'https://www.airmeet.com/e/d9f96f90-81c7-11eb-95ad-bb2c7c31b8f9',
                    data: [
                        {
                            name:"Introduction",
                            type:'text',
                            content:'Elan & ηvision 2021, IIT Hyderabad proudly presents its circuit designing event "Circuit Building". It\'s time to show your circuit designing skills and win some awesome prizes. Get ready circuit nerds to show off your expertise in designing circuits during ELAN & ηvision 2021.\n'
                        },
                        {
                            name:"STRUCTURE:",
                            type:'text',
                            content:'This is a single-round live contest, teams will have to work and submit the solutions within the given time limit.'
                        },
                        {
                            name:"TIMELINE:",
                            type:'table',
                            content:{
                                left:[
                                    'Registration Start Date',
                                    'Registration End Date',
                                    'Event Time',
                                    'Winner Announcement',
                                ],
                                right:[
                                    '13/02/2021',
                                    '10/03/2021',
                                    '9:00  to 12:00 on 13/03/2021',
                                    '14/03/2021',
                                ]
                            }
                        },
                        {
                            name:"PROBLEM STATEMENT:",
                            type:'list',
                            content:[
                                'This will be an on-spot designing contest.',
                                'A problem statement will be provided for the registered groups for which they are expected to design a circuit (which meets the requirements) and simulate it',
                                'Participants are expected to simulate the circuit design in LTspice and submit a .asc file along with the results (format will be provided along with the problem). ',
                            ]
                        },
                        {
                            name:"JUDGING CRITERIA:",
                            type:'list',
                            content:[
                                'Any sign of plagiarism from the internet or from other participants will lead to direct disqualification.\n',
                                'Participants can only submit once. In case of multiple submissions only the first entry will be considered for evaluation.\n',
                                'The design will be evaluated on the following aspects :\n' +
                                'Simplicity and comprehensibility of the design.\n' +
                                'Submission time per problem.\n' +
                                'Clarity in naming conventions for the circuit elements and design files\n',
                                'Certificate of Merit and Prizes will be given for the top two teams',
                                'Participation Certificate will be given for those who registered online and participated in the event',
                                'Participation Certificates will not be given to the participants who are not present at the time of event',
                                'Disqualified teams will also not be considered for any certificates.',
                            ]
                        },
                        {
                            name:"SUBMISSION FORMAT:",
                            type:'text',
                            content:'Each team has to upload the files in the above specified format in the submission form available in the website during the event.'
                        },
                        {
                            name:"EVENT RULES:",
                            type:'list',
                            content:[
                                'Each team can have a maximum of two participants',
                                'Decisions of the organizers will be final and binding. No claim will be entertained against the announced results.',

                            ]
                        },
                        {
                            name:"REGISTRATION DETAILS:",
                            type:'text',
                            content:'Each participant has to register for the event by filling their details in the\n' +
                                'registration form available on the Elan and Nvision 2021 Website\n' +
                                '(https://elan.org.in/competitions)'
                        },
                        {
                            name:"CERTIFICATES AND PRIZES::",
                            type:'list',
                            content:[
                                'The top two teams will receive prizes of worth Rs. 12,000.',
                                'This prize money will be awarded via NEFT and will be processed within 30\n' +
                                'working days.',
                                'The winner will be notified via email sent from(elan@iith.ac.in).',
                                'E-certificate of Participation will be given to all the participants who have\n' +
                                'submitted their model via submission form',
                                'E-certificate of Excellence will be given to the top 2 teams.',
                            ]
                        },
                        {
                            name:"CONTACT DETAILS:",
                            type:'contact',
                            content:[
                                {
                                    name:'Organiser Name: R V B R N Aaseesh',
                                    mobile:'Mobile Number: 7032655929 '
                                },
                                {
                                    name:'Organiser Name:  Deekshitha reddy',
                                    mobile:'Mobile Number: 7330784699'
                                },
                            ]
                        },

                    ]
                },
            },
            {
                name:'Code Arduino',
                photo:ArduinoCoding,
                platformIndependent:true,
                details:"The competition aims to test the knowledge of  participants on Arduino IDE. So Get ready to show off your arduino coding skills to get the desired output.\n",
                rules:'https://drive.google.com/file/d/1w43x60uYMsI1si2unr47Rd3V9t7-O9Nv/view',
                //submit:'',
                modal: {
                    sp1:Arcesium ,
                    name:'Code Arduino',
                    data: [
                        {
                            name:"Introduction",
                            type:'text',
                            content:' Elan & ηvision 2021, IIT Hyderabad proudly presents its code event "Code Arduino". It\'s time to show your circuit designing skills and win some awesome prizes. Get ready circuit nerds to show off your expertise in designing circuits during ELAN & ηvision 2021.'
                        },
                        {
                            name:"STRUCTURE:",
                            type:'text',
                            content:'This is a single-round live contest, teams will have to work and submit the solutions within the given time limit'
                        },
                        {
                            name:"TIMELINE:",
                            type:'table',
                            content:{
                                left:[
                                    'Registration Start Date',
                                    'Registration End Date',
                                    'Event Time',
                                    'Winner Announcement',
                                ],
                                right:[
                                    '13/02/2021',
                                    '10/03/2021',
                                    '13:00 to 16:00 on 12/03/2021',
                                    '14/03/2021',
                                ]
                            }
                        },
                        {
                            name:"PROBLEM STATEMENT:",
                            type:'list',
                            content:[
                                'This will be an on-spot designing contest.',
                                'An open ended problem statement will be provided for the registered groups for which they are expected to design an arduino circuit (which meets the requirements) and simulate it in https://www.tinkercad.com/',
                                'Participants are expected to simulate the Arduino circuit design and submit the circuit design (share the link via google forms).'
                            ]
                        },
                        {
                            name:"JUDGING CRITERIA:",
                            type:'list',
                            content:[
                                'Any sign of plagiarism from the internet or from other participants will lead to direct disqualification',
                                'Participants can only submit once. In case of multiple submissions only the first entry will be considered for evaluation',
                                'The design will be evaluated on the following aspects :\n' +
                                'Number/novelty of different sensible features implemented.\n' +
                                'Submission time.\n',
                                'Certificate of Merit and Prizes will be given for the top two teams',
                                'Participation Certificate will be given for those who registered online and participated in the event',
                                'Participation Certificates will not be given to the participants who are not present at the time of event.',
                                'Disqualified teams will also not be considered for any certificates.'
                            ]
                        },
                        {
                            name:"SUBMISSION FORMAT:",
                            type:'text',
                            content:'Each team has to upload the files in the above specified format in the submission form available in the website during the event.'
                        },
                        {
                            name:"EVENT RULES:",
                            type:'list',
                            content:[
                                'Each team can have a maximum of two participants.',
                                'Decisions of the organizers will be final and binding. No claim will be entertained against the announced results.'

                            ]
                        },
                        {
                            name:"REGISTRATION DETAILS:",
                            type:'text',
                            content:'Each participant has to register for the event by filling their details in the\n' +
                                'registration form available on the Elan and Nvision 2021 Website\n' +
                                '(https://elan.org.in/competitions)'
                        },
                        {
                            name:"CERTIFICATES AND PRIZES::",
                            type:'list',
                            content:[
                                'The top two teams will receive prizes of worth Rs. 10,000.',
                                'This prize money will be awarded via NEFT and will be processed within 30\n' +
                                'working days.',
                                'The winner will be notified via email sent from(elan@iith.ac.in).',
                                'E-certificate of Participation will be given to all the participants who have\n' +
                                'submitted their model via submission form',
                                'E-certificate of Excellence will be given to the top 2 teams.',
                            ]
                        },
                        {
                            name:"CONTACT DETAILS:",
                            type:'contact',
                            content:[
                                {
                                    name:'Organiser Name: Aditya Somasundaram',
                                    mobile:'Mobile Number: 9901330016 '
                                },
                                {
                                    name:'Organiser Name: Arpita Gautam ',
                                    mobile:'Mobile Number: 9326519305'
                                },
                            ]
                        },

                    ]
                },
            },//4
            {
                name:'Web Development',
                photo:WebDev,
                platformIndependent:true,
                details:"An event that empowers the creative and technically proficient future Web professionals.Participants can Innovate and Inspire by designing a creative Website in this competition.",
                rules:'https://drive.google.com/file/d/1Mb5b9xpsCIR3E64CaBPPgfYeHS8w3RNu/view',
                //submit:'',
                modal: {
                    sp1:Arcesium ,
                    sp2:CodingNinjas,
                    name:'Web Development',
                    link:'https://www.airmeet.com/e/f48e8260-81c6-11eb-bd09-470731bf14b4',
                    data: [
                        {
                            name:"Introduction",
                            type:'text',
                            content:'Elan & ηvision 2021, IIT Hyderabad proudly presents its web designing hackathon. An event that empowers the creative minds to showcase their work to the world. It is a three days competition that challenges participants to create innovative webapp during ELAN & ηvision 2021.\n'
                        },
                        {
                            name:"STRUCTURE:",
                            type:'text',
                            content:'The hackathon will last for a total of 72 hours. Winners are decided in 48 hours after the hackathon.'
                        },
                        {
                            name:"TIMELINE:",
                            type:'table',
                            content:{
                                left:[
                                    'Registration Start Date',
                                    'Registration End Date',
                                    'Event Time',
                                    'Winner Announcement',
                                ],
                                right:[
                                    '13/02/2021',
                                    '10/03/2021',
                                    '11/03/2021 5pm to 14/03/2021 5pm',
                                    '17/03/2021',
                                ]
                            }
                        },
                        {
                            name:"PROBLEM STATEMENT:",
                            type:'text',
                            content:'Participants are required to create a webapp based on the theme i.e given at the start of hackathon.'
                        },
                        {
                            name:"JUDGING CRITERIA:",
                            type:'table',
                            content:{
                                left:[
                                    'Features',
                                    'Reliability',
                                    'Technical Difficulty',
                                    'User Experience',
                                    'Presentation',
                                    'Code Quality',
                                ],
                                right:[
                                    '30%',
                                    '20%',
                                    '20%',
                                    '10%',
                                    '10%',
                                    '10%',
                                ]
                            }
                        },
                        {
                            name:"SUBMISSION FORMAT:",
                            type:'list',
                            content:[
                                'Before the end of the stipulated 72 hours, teams are required to\n' +
                                'submit their code in a private Github repository shared with a limited\n' +
                                'number of Github IDs.',
                                'All the teams should also submit pre-built release versions of their\n' +
                                'applications for all major platforms that clients may use. Example:\n' +
                                'Pre-built post-Lollipop APKs for Android.',
                                'The submission Github repository should contain a README.md with\n' +
                                'detailed instructions on how to build all your software on a Linux\n' +
                                'machine running Ubuntu 18.04/20.04 LTS.',

                            ]
                        },
                        {
                            name:"EVENT RULES:",
                            type:'list',
                            content:[
                                'Teams should not use any proprietary library in their code. All\n' +
                                'APIs/SDKs/Libraries used in the development of your project should\n' +
                                'be open-source.',
                                'A team can submit only one entry for the contest. Participation in the\n' +
                                'event is subjected on a “per-team” basis meaning you are not allowed\n' +
                                'to be on more than one teams at the event.',
                                'Any intellectual property developed during and within the scope of the\n' +
                                'hackathon must be open source and licensed under one of the\n' +
                                'licenses referenced in Open Source licenses & Standards.',
                                'Teams are also required to give an interactive demonstration of the\n' +
                                'project to a panel of judges, who might ask questions specific to\n' +
                                'either the implementation or usability of your project.',
                                'Teams can have a maximum of 4 participants.',
                                'All decisions taken by the organisers and judges will be final and\n' +
                                'binding.',

                            ]
                        },
                        {
                            name:"REGISTRATION DETAILS:",
                            type:'text',
                            content:'Each participant has to register for the event by filling their details in the\n' +
                                'registration form available on the Elan and Nvision 2021 Website\n' +
                                '(https://elan.org.in/competitions)'
                        },
                        {
                            name:"CERTIFICATES AND PRIZES::",
                            type:'list',
                            content:[
                                'The top two teams will receive prizes of worth Rs. 20,000.',
                                'This prize money will be awarded via NEFT and will be processed within 30\n' +
                                'working days.',
                                'The winner will be notified via email sent from(elan@iith.ac.in).',
                                'E-certificate of Participation will be given to all the participants who have\n' +
                                'submitted their model via submission form',
                                'E-certificate of Excellence will be given to the top 2 teams.',
                            ]
                        },
                        {
                            name:"CONTACT DETAILS:",
                            type:'contact',
                            content:[
                                {
                                    name:'Organiser Name: B. Charan Chandra',
                                    mobile:'Mobile Number: 9398577068 '
                                },
                                {
                                    name:'Organiser Name: Tanmay Shah',
                                    mobile:'Mobile Number: 9370294588'
                                },
                            ]
                        },

                    ]
                },
            },
            {
                name:'Proquest',
                photo:Proquest,
                platformIndependent:true,
                details:"Experience the Competitive Programming Competition , for all participants of all levels of expertise. This event ensures that even an absolute beginner is able to solve something. So Get your Hands Dirty.\n",
                rules:'https://drive.google.com/file/d/1_s4Yd9p3sp6EmFWRXXvbthkOYERfRLVr/view',
                //submit:'',
                modal: {
                    sp1:Arcesium ,
                    sp2:CodingNinjas,
                    name:'Proquest',
                    data: [
                        {
                            name:"Introduction",
                            type:'text',
                            content:'Elan & ηvision 2021, IIT Hyderabad proudly presents its Coding event "Proquest". Proquest is a competitive programming competition composed of a single level, for participants of all levels of expertise. Compete against other coders and solve the questions prepared by the geekiest coders of IIT Hyderabad. It is an on the spot online coding competition to show your coding skills during ELAN & ηvision 2021.'
                        },
                        {
                            name:"STRUCTURE:",
                            type:'text',
                            content:'This event will be held in a single round. It will be hosted on Hackerrank.\n' +
                                'This is a 3 hour round. The top 2 participants will be declared as winner\n' +
                                'and runner up in this round.'
                        },
                        {
                            name:"TIMELINE:",
                            type:'table',
                            content:{
                                left:[
                                    'Registration Start Date',
                                    'Registration End Date',
                                    'Event Time',
                                    'Winner Announcement',
                                ],
                                right:[
                                    '13/02/2021',
                                    '10/03/2021',
                                    '15:00 to 18:00 on 14/03/2021',
                                    '14/03/2021',
                                ]
                            }
                        },
                        // {
                        //     name:"PROBLEM STATEMENT:",
                        //     type:'text',
                        //     content:'Participants are required to create an app'+
                        //         'based on the theme i.e given at the start of hackathon.'
                        // },
                        {
                            name:"JUDGING CRITERIA:",
                            type:'list',
                            content:[
                                'Depending on the complexity of each test case, the scoring\n' +
                                'mechanism is allocated partial marks and all the constraints will be\n' +
                                'mentioned in the hackerrank platform along with the question',
                                'The score of each participant of each round can be viewed on the leaderboard of the hackerrank platform.',
                                ' Participants involved in any sort of plagiarism will be disqualified from the competition and will not be considered to further rounds.',
                                'The top 2 participants having highest scores amongst the participants will be announced as winner and runner up for the competition.'
                            ]
                        },
                        // {
                        //     name:"SUBMISSION FORMAT:",
                        //     type:'list',
                        //     content:[
                        //         'Before the end of the stipulated 72 hours, teams are required to\n' +
                        //         'submit their code in a private Github repository shared with a limited\n' +
                        //         'number of Github IDs.',
                        //         'All the teams should also submit pre-built release versions of their\n' +
                        //         'applications for all major platforms that clients may use. Example:\n' +
                        //         'Pre-built post-Lollipop APKs for Android.',
                        //         'The submission Github repository should contain a README.md with\n' +
                        //         'detailed instructions on how to build all your software on a Linux\n' +
                        //         'machine running Ubuntu 18.04/20.04 LTS.',
                        //
                        //     ]
                        // },
                        {
                            name:"EVENT RULES:",
                            type:'list',
                            content:[
                                'This is an individual event. No teams are allowed.',
                                'Any form of plagiarism would immediately lead to disqualification.',
                                'The organisers reserve the right to make any change to the event whenever deemed necessary.',
                                'All decisions made by the judges will be final and binding.'

                            ]
                        },
                        {
                            name:"REGISTRATION DETAILS:",
                            type:'text',
                            content:'Each participant has to register for the event by filling their details in the\n' +
                                'registration form available on the Elan and Nvision 2021 Website\n' +
                                '(https://elan.org.in/competitions)'
                        },
                        {
                            name:"CERTIFICATES AND PRIZES::",
                            type:'list',
                            content:[
                                'The top two teams will receive prizes of worth Rs. 20,000.',
                                'This prize money will be awarded via NEFT and will be processed within 30\n' +
                                'working days.',
                                'The winner will be notified via email sent from(elan@iith.ac.in).',
                                'E-certificate of Participation will be given to all the participants who have\n' +
                                'submitted their model via submission form',
                                'E-certificate of Excellence will be given to the top 2 teams.',
                            ]
                        },
                        {
                            name:"CONTACT DETAILS:",
                            type:'contact',
                            content:[
                                {
                                    name:'Organiser Name: Atharv Ramesh Nair',
                                    mobile:'Mobile Number: 7550124926 '
                                },
                                {
                                    name:'Organiser Name: Kn Vardhan',
                                    mobile:'Mobile Number: 9652793113'
                                },
                            ]
                        },

                    ]
                },
            },
            {
                name:'Machina Doctrina’s',
                photo:Machina,
                platformIndependent:true,
                details:"If making machines learn is your forté, this is the perfect event for you. Test and hone your skills in ML and Data Analytics by participating in Machina doctrinas, one of the coolest events in the fest!",
                rules:'https://drive.google.com/file/d/1ZETo8rW4BomSQpoJM-JUdpMEqmV4TvYG/view',
                //submit:'',
                modal: {
                    sp1:Arcesium ,
                    name:'Machina Doctrina’s',
                    data: [
                        {
                            name:"Introduction",
                            type:'text',
                            content:'Elan & ηvision 2021, IIT Hyderabad proudly presents its Machine Learning and Data Analytics event "Machina Doctrina’s". This contest focuses on Machine Learning Understanding and Coding Skills of an individual/group. Participate in the contest to show off your expertise in ML during ELAN & ηvision 2021.'
                        },
                        {
                            name:"STRUCTURE:",
                            type:'text',
                            content:'A single stage on-the-spot contest, held during the fest  itself. Winners are decided straight after the evaluation of this single round.'
                        },
                        {
                            name:"TIMELINE:",
                            type:'table',
                            content:{
                                left:[
                                    'Registration Start Date',
                                    'Registration End Date',
                                    'Event Time',
                                    'Winner Announcement',
                                ],
                                right:[
                                    '13/02/2021',
                                    '10/03/2021',
                                    '11:00 to 15:00 on 14/03/2021\n',
                                    '14/03/2021',
                                ]
                            }
                        },
                        {
                            name:"PROBLEM STATEMENT:",
                            type:'text',
                            content:'It will be an on-spot 3-hour contest round. The contest is hosted on\n' +
                                'Kaggle. An individual or a group of maximum two can participate in\n' +
                                'the contest.'
                        },
                        {
                            name:"JUDGING CRITERIA:",
                            type:'list',
                            content:[
                                'The first two submissions satisfying the prerequisites (which will be mentioned during the contest) will get prizes.',
                                'If there is a clash between 2 submissions, an individual contestant is given more preference than a group of contestants.',
                                'In case of a further clash between submissions, the participant who submits first gets preference.',
                                'Decisions of the organizers will be final and binding. No claim will be entertained against the announced results.'
                            ]
                        },
                        {
                            name:"EVENT RULES:",
                            type:'list',
                            content:[
                                'Participants can be an individual or a team of 2.',
                                'Usage of the Internet is allowed.',
                                'Deep Learning solutions using Neural Networks will not be accepted.'

                            ]
                        },
                        {
                            name:"REGISTRATION DETAILS:",
                            type:'text',
                            content:'Each participant has to register for the event by filling their details in the\n' +
                                'registration form available on the Elan and Nvision 2021 Website\n' +
                                '(https://elan.org.in/competitions)'
                        },
                        {
                            name:"CERTIFICATES AND PRIZES::",
                            type:'list',
                            content:[
                                'The top two teams will receive prizes of worth Rs. 10,000.',
                                'This prize money will be awarded via NEFT and will be processed within 30\n' +
                                'working days.',
                                'The winner will be notified via email sent from(elan@iith.ac.in).',
                                'E-certificate of Participation will be given to all the participants who have\n' +
                                'submitted their model via submission form',
                                'E-certificate of Excellence will be given to the top 2 teams.',
                            ]
                        },
                        {
                            name:"CONTACT DETAILS:",
                            type:'contact',
                            content:[
                                {
                                    name:'Organiser Name: T. Shashidhar Rao',
                                    mobile:'Mobile Number: 7013583615'
                                },
                                {
                                    name:'Organiser Name: Stephen V S ',
                                    mobile:'Mobile Number: 81369 38412'
                                },
                            ]
                        },

                    ]
                },
            },
            {
                name:'DeepN',
                photo:DeepN,
                platformIndependent:true,
                details:"If Technology had a face now, it would be ‘AI’. An on-spot challenge that promises to flex your ‘neurons’ and would surely test your understanding of Deep Learning ",
                rules:'https://drive.google.com/file/d/1e9cebpBaEboPim9ayl4ngz3LBF5PG2Ql/view',
                //submit:'',
                modal: {
                    sp1:Arcesium ,
                    name:'DeepN',
                    data: [
                        {
                            name:"Introduction",
                            type:'text',
                            content:'Elan & ηvision 2021, IIT Hyderabad proudly presents its Deep Learning event "DeepN". This contest promises to flex your ‘neurons’ and would surely test your understanding of Deep Learning. Participate in the contest to show off your expertise in Deep Learning during ELAN & ηvision 2021'
                        },
                        {
                            name:"STRUCTURE:",
                            type:'text',
                            content:'A single stage on-the-spot contest, held during the fest itself. Winners are decided straight after the evaluation of this single round'
                        },
                        {
                            name:"TIMELINE:",
                            type:'table',
                            content:{
                                left:[
                                    'Registration Start Date',
                                    'Registration End Date',
                                    'Event Time',
                                    'Winner Announcement',
                                ],
                                right:[
                                    '13/02/2021',
                                    '10/03/2021',
                                    '12:00 to 23:59 on 13/03/2021',
                                    '14/03/2021',
                                ]
                            }
                        },
                        {
                            name:"PROBLEM STATEMENT:",
                            type:'text',
                            content:'This contest focuses on Deep Learning Understanding and Coding\n' +
                                'Skills of an individual/group. Complete Question along with the\n' +
                                'dataset and some more instructions will be provided just before the\n' +
                                'contest.The event will be held on Kaggle.'
                        },
                        {
                            name:"JUDGING CRITERIA:",
                            type:'list',
                            content:[
                                'The first two submissions satisfying the prerequisites (which will be mentioned during the contest) will get prizes.',
                                'If there is a clash between 2 submissions, an individual contestant is given more preference than a group of contestants.',
                                'In case of a further clash between submissions, the participant who submits first gets preference',
                                'Decisions of the organizers will be final and binding. No claim will be entertained against the announced results',
                            ]
                        },

                        {
                            name:"EVENT RULES:",
                            type:'list',
                            content:[
                                'Participants can be an individual or a team of 2',
                                'Usage of the Internet is allowed.',

                            ]
                        },
                        {
                            name:"REGISTRATION DETAILS:",
                            type:'text',
                            content:'Each participant has to register for the event by filling their details in the\n' +
                                'registration form available on the Elan and Nvision 2021 Website\n' +
                                '(https://elan.org.in/competitions)'
                        },
                        {
                            name:"CERTIFICATES AND PRIZES::",
                            type:'list',
                            content:[
                                'The top two teams will receive prizes of worth Rs. 10,000.',
                                'This prize money will be awarded via NEFT and will be processed within 30\n' +
                                'working days.',
                                'The winner will be notified via email sent from(elan@iith.ac.in).',
                                'E-certificate of Participation will be given to all the participants who have\n' +
                                'submitted their model via submission form',
                                'E-certificate of Excellence will be given to the top 2 teams.',
                            ]
                        },
                        {
                            name:"CONTACT DETAILS:",
                            type:'contact',
                            content:[
                                {
                                    name:'Organiser Name: Satwik Arawalli',
                                    mobile:'Mobile Number: 8217435039 '
                                },
                                {
                                    name:'Organiser Name: Sri Varshitha Manduri',
                                    mobile:'Mobile Number: 9154619754'
                                },
                            ]
                        },

                    ]
                },
            },
            {
                name:'Paper Presentation',
                photo:PaperPresentation,
                details:"In this event, contestants prepare a presentation that showcases and effectively presents new ideas related to any field or even an entire business plan. The main idea of the event is to analyse a topic and think with a new bent of mind.\n",
                rules:'https://drive.google.com/file/d/1H1ZFTBVYx_a3U7K6kaJcZJs89AzqdLwB/view?usp=sharing',
                submit:'https://docs.google.com/forms/d/1knR5S9C0G36PuZnRgYhtMuD4Zcnd__Ebk-25okshC34/viewform?edit_requested=true',
                modal: {
                    sp1:Arcesium ,
                    name:'Paper Presentation',
                    link:'https://www.airmeet.com/e/370f00f0-80dd-11eb-92df-677d899a473c',
                    data: [
                        {
                            name:"Introduction",
                            type:'text',
                            content:'Elan & ηvision 2021, IIT Hyderabad proudly presents its exploration event "Paper Presentation". An out-and-out platform where students from all backgrounds manifest their research work by presenting their proficient papers related to various topics in the fields of science and engineering to ingenious judges. You are expected to send an abstract of your work (15 days prior) based on which you will be qualified to present your paper during ELAN & ηvision 2021.'
                        },
                        {
                            name:"STRUCTURE:",
                            type:'list',
                            content:[
                                'This event is held in two rounds.',
                                'Round 1 - All the participants are required to submit their abstract before the deadline mentioned in the timeline section. Failing to do so will lead to disqualification and also will not be considered for the further rounds.\n',
                                'Best and top 30% - 40% of the total Abstracts (that match the given requirements) are selected for 2nd Round based on the judging criteria.',
                                'Abstracts that are selected for Round 2 will be announced on our website on the date mentioned in the timeline section.',
                                'Round 2 - Qualified abstract’s are required to present their work in an illustrative manner(ppt) to all the judges on the date of fest. Failing to be present/ to give the presentation at the time allocated to the participant will lead to disqualification.',
                                'Most illustrative and top two abstracts will be awarded after the 2nd    Round based on the judging criteria.'
                            ]
                        },
                        {
                            name:"TIMELINE:",
                            type:'table',
                            content:{
                                left:[
                                    'Registration Start Date',
                                    'Submission Deadline for Abstract',
                                    'Announcement of Round 2 Qualifiers',
                                    'Round 2',
                                    'Winner Announcement',
                                ],
                                right:[
                                    '13/02/2021',
                                    'March 1, 2021 11:59PM',
                                    'March 7, 2021 4:00PM',
                                    'March 14, 2021 \n' +
                                    '1:00PM - 4:00PM\n',
                                    'March 14, 2021 7:00PM'
                                ]
                            }
                        },
                        {
                            name:"JUDGING CRITERIA:",
                            type:'list',
                            content:[
                                'ABSTRACT :\n',
                                'The abstract should be simple yet clear about your topic of research.',
                                'The topic on which the research is done should strive to make the human life a better one.',
                                'If the topic about which the abstract is submitted is an extension to one of the works done earlier but a better version of that.The ways in which it is a better one should be mentioned.',
                                'ROUND 2 :',
                                'Correctness of facts.',
                                'Methods of analysis',
                                'Innovativeness of idea.',
                                'Presentation of solution or ideas.',
                                'Practical feasibility or implication of ideas.'
                            ]
                        },
                        {
                            name:"SUBMISSION FORMAT:",
                            type:'text',
                            content:'The participant has to upload their abstract in either pdf/word/docs format in the Submission form that is available in the website. The participant can also share the github link in form.'
                        },
                        {
                            name:"EVENT RULES:",
                            type:'list',
                            content:[
                                'Shortlisting will be done based on Abstracts.',
                                'All relevant data and figures must be represented in the paper.',
                                'The Abstract should be submitted in Size 11, BOLD, Calibri.',
                                'The following details have to be mentioned in the Abstract.\n' +
                                'Workplace and the work done there.\n' +
                                'Supervisor /scientist under whom the work is done.\n' +
                                'Abstract in 200-250 words.\n' +
                                'Keywords.\n' +
                                'References/ source of your study.\n' +
                                'Background and scope of the paper in 200-250 words.\n',
                                'Teams of maximum 2 members are allowed.',
                                'The Organizer\'s decision will be final and binding.',
                                'All results will be announced on the website and will be mailed to the team Members.',
                                'Add your team ELAN ID and team member details (Names, ELAN ID’s, Mail IDs) to the abstract.',
                                'Any abstract that is selected for stage 2 and is not presented shall not qualify for any award.'

                            ]
                        },
                        {
                            name:"REGISTRATION DETAILS:",
                            type:'text',
                            content:'Each participant has to register for the event by filling their details in the\n' +
                                'registration form available on the Elan and Nvision 2021 Website\n' +
                                '(https://elan.org.in/competitions)'
                        },
                        {
                            name:"CERTIFICATES AND PRIZES::",
                            type:'list',
                            content:[
                                'The top two teams will receive prizes of worth Rs. 20,000.',
                                'This prize money will be awarded via NEFT and will be processed within 30\n' +
                                'working days.',
                                'The winner will be notified via email sent from(elan@iith.ac.in).',
                                'E-certificate of Participation will be given to all the participants who have\n' +
                                'submitted their model via submission form',
                                'E-certificate of Excellence will be given to the top 2 teams.',
                            ]
                        },
                        {
                            name:"CONTACT DETAILS:",
                            type:'contact',
                            content:[
                                {
                                    name:'Organiser Name: Sailesh Reddy M',
                                    mobile:'Mobile Number: 9740834746'
                                },
                                {
                                    name:'Organiser Name: K.Madhumitha',
                                    mobile:'Mobile Number: 8309567379'
                                },
                            ]
                        },

                    ]
                },
            },//9
            {
                name:'Hackathon',
                photo:Hackathon,
                platformIndependent:true,

                details:"A unique hackathon on emerging digital technologies to engage with tech enthusiasts. It offers an array of challenges across multiple levels.",
                rules:'',
                //submit:'',
                modal: {
                    sp1:Arcesium ,
                    name:'Hackathon',
                    data: [
                        {
                            name:"Introduction",
                            type:'text',
                            content:'Elan & ηvision 2021, IIT Hyderabad\n' +
                                'proudly presents its hackathon competition. An event that challenges\n' +
                                'participants to create innovative prototypes for their ideas. It is a 24hrs\n' +
                                'competition, so grab the chance to influence creativity and innovation by\n' +
                                'designing a peculiar development during ELAN & ηvision 2021.'
                        },
                        {
                            name:"STRUCTURE:",
                            type:'text',
                            content:'The hackathon will last for a total of 24 hours.'
                        },
                        {
                            name:"TIMELINE:",
                            type:'table',
                            content:{
                                left:[
                                    'Registration Start Date',
                                    'Registration End Date',
                                    'Event Time',
                                    'Winner Announcement',
                                ],
                                right:[
                                    '13/02/2021',
                                    '10/03/2021',
                                    '12/03/2021 5pm to 13/03/2021\n' +
                                    '5pm\n',
                                    '14/03/2021',
                                ]
                            }
                        },
                        {
                            name:"PROBLEM STATEMENT:",
                            type:'text',
                            content:'The theme for the hackathon and the exact problem statement in which\n' +
                                'the participant needs to develop their prototype (either hardware/\n' +
                                'software) will be presented live on 12th March 2021, 5PM. The\n' +
                                'participants will have 24hrs to develop their prototype. If the prototype is\n' +
                                'involving a hardware part the participants needs to submit a video of its\n' +
                                'working. If the prototype is a software code the participant will need to\n' +
                                'upload it into their git repository and should submit the github link in the\n' +
                                'form provided for submission that will be available in the website as well\n' +
                                'shared to the participant via email.'
                        },
                        // {
                        //     name:"JUDGING CRITERIA:",
                        //     type:'table',
                        //     content:{
                        //         left:[
                        //             'Features',
                        //             'Reliability',
                        //             'Technical Difficulty',
                        //             'User Experience',
                        //             'Presentation',
                        //             'Code Quality',
                        //         ],
                        //         right:[
                        //             '30%',
                        //             '20%',
                        //             '20%',
                        //             '10%',
                        //             '10%',
                        //             '10%',
                        //         ]
                        //     }
                        // },
                        {
                            name:"SUBMISSION FORMAT:",
                            type:'list',
                            content:[
                                'If the prototype is involving a hardware part the participants needs\n' +
                                'to submit a video of its working.\n',
                                'If the prototype is involving any software then the teams are\n' +
                                'required to submit their code in a private Github repository shared\n' +
                                'with a limited number of Github IDs.\n' ,
                                'The submission Github repository should contain a README.md\n' +
                                'with detailed instructions on how to build all your software on a\n' +
                                'Linux machine running Ubuntu 18.04/20.04 LTS.',

                            ]
                        },
                        {
                            name:"EVENT RULES:",
                            type:'list',
                            content:[
                                'A team can submit only one entry for the contest. Participation in\n' +
                                'the event is subjected on a “per-team” basis meaning you are not\n' +
                                'allowed to be on more than one teams at the event.\n' ,
                                'Any intellectual property developed during and within the scope of\n' +
                                'the hackathon must be open source and licensed under one of the\n' +
                                'licenses referenced in Open Source licenses & Standards.\n' ,
                                'Teams are also required to give an interactive demonstration of\n' +
                                'the project to a panel of judges, who might ask questions specific\n' +
                                'to either the implementation or usability of your project.\n' ,
                                'Teams can have a maximum of 4 participants.\n' ,
                                'All decisions taken by the organisers and judges will be final and\n' +
                                'binding.',

                            ]
                        },
                        {
                            name:"REGISTRATION DETAILS:",
                            type:'text',
                            content:'Each participant has to register for the event by filling their details in the\n' +
                                'registration form available on the Elan and Nvision 2021 Website\n' +
                                '(https://elan.org.in/competitions)'
                        },
                        {
                            name:"CERTIFICATES AND PRIZES::",
                            type:'list',
                            content:[
                                'The top two teams will receive prizes of worth Rs. 20,000.',
                                'This prize money will be awarded via NEFT and will be processed within 30\n' +
                                'working days.',
                                'The winner will be notified via email sent from(elan@iith.ac.in).',
                                'E-certificate of Participation will be given to all the participants who have\n' +
                                'submitted their model via submission form',
                                'E-certificate of Excellence will be given to the top 2 teams.',
                            ]
                        },
                        {
                            name:"CONTACT DETAILS:",
                            type:'contact',
                            content:[
                                {
                                    name:'Organiser Name: Varunaditya',
                                    mobile:'Mobile Number: 7015715920'
                                },
                                {
                                    name:'Organiser Name: Vishal Datta',
                                    mobile:'Mobile Number: 7670925438'
                                },
                            ]
                        },

                    ]
                },
            },
            {
                name:'SharkTank',
                photo:SharkTank,
                details:"Pitch is the first thing that is required by any entrepreneur. In this event participants have to pitch their ideas in front of a large audience in an online mode. Test your skills against other budding entrepreneurs.",
                rules:'https://drive.google.com/file/d/1UfU6jP4chssx9QdUMe2X5PS09a9i36SQ/view',
                submit: 'https://docs.google.com/forms/d/18fU-phC-KgvCVrE2BgIFwTRnEGza-bwuCmHrZEkVV8g/viewform?edit_requested=true',
                modal: {
                    sp1:Arcesium,
                    name:'SharkTank',
                    link:'https://www.airmeet.com/e/e2b3f610-80db-11eb-9d02-0dd6bd89460e',
                    data: [
                        {
                            name:"Introduction",
                            type:'text',
                            content:'Elan & ηvision 2021, IIT Hyderabad proudly presents its pitching event "Shark Tank". Pitch is the first thing that is required by any entrepreneur. In this event participants have to pitch their ideas in front of a large crowd. Test your skills against other budding entrepreneurs during ELAN & ηvision 2021.'
                        },
                        {
                            name:"STRUCTURE:",
                            type:'text',
                            content:'A two level contest, with the final stage held on the fest day. Winners are decided after the final round.'
                        },
                        {
                            name:"TIMELINE:",
                            type:'table',
                            content:{
                                left:[
                                    'Registration Start Date',
                                    'Registration End Date',
                                    'Event Time',
                                    'Winner Announcement',
                                ],
                                right:[
                                    '13/02/2021',
                                    '7/03/2021',
                                    '14:00 to 16:00 on 12/03/2021',
                                    '14/03/2021',
                                ]
                            }
                        },
                        {
                            name:"PROBLEM STATEMENT:",
                            type:'list',
                            content:[
                                'Startup/Pitching Categories:',
                                'Technology/Startup/Ecommerce/Games\n',
                                'Movies/Music/Theatre',
                                'Art /Design/Fashion',
                                'Sports',
                                'Photography',
                                'Book and Publishing/Comics',
                                'Community and Healthcare',
                                'Education',
                                'Food and restaurant',
                                'STAGE 1 (Filtering) : BRIEF YOUR IDEA',
                                'Submit your projects in the form that is available on our website. Last date for submission of projects is 5 days prior to the event (i.e 07/03/2021).',
                                'STAGE 2 : PITCH YOUR IDEA',
                                '15 shortlisted teams- will be allowed to make a 5 minutes live pitch at the session at ELAN&ηvision 2021. They need to convince the judges and the crowd why they think the crowd should invest in their ideas ? Explain pros and cons.',
                                'STAGE 3 : VIRTUAL CROWDFUNDING',
                                'Every participant will be given a virtual currency of INR 10,000. The Pitchers will be asking the participants to fund their idea through the virtual money. ',
                            ]
                        },
                        {
                            name:"JUDGING CRITERIA:",
                            type:'text',
                            content:'Top two ideas which receive the highest fund amounts and which are selected by Judges will be the winner.'
                        },
                        {
                            name:"EVENT RULES:",
                            type:'list',
                            content:[
                                'Individual Participation. This is a solo competition and participants cannot participate in teams for this event.\n',
                                'The event will take place online over airmeet.',
                                'All the participants are given equal amount at the start.\n',
                                'Participants cannot spend any money on their own idea.',
                                'Participants cannot spend more than half of their money on one single idea.',
                                'Each participant has to spend his/her money on at least three ideas.',
                                'Participants have to spend all of their money',
                                'Decisions of the organizers/judges will be final and binding. No claim will be entertained against the announced results.',


                            ]
                        },
                        {
                            name:"REGISTRATION DETAILS:",
                            type:'text',
                            content:'Each participant has to register for the event by filling their details in the\n' +
                                'registration form available on the Elan and Nvision 2021 Website\n' +
                                '(https://elan.org.in/competitions)'
                        },
                        {
                            name:"CERTIFICATES AND PRIZES::",
                            type:'list',
                            content:[
                                'The top two teams will receive prizes of worth Rs. 3,000.',
                                'This prize money will be awarded via NEFT and will be processed within 30\n' +
                                'working days.',
                                'The winner will be notified via email sent from(elan@iith.ac.in).',
                                'E-certificate of Participation will be given to all the participants who have\n' +
                                'submitted their model via submission form',
                                'E-certificate of Excellence will be given to the top 2 teams.',
                            ]
                        },
                        {
                            name:"CONTACT DETAILS:",
                            type:'contact',
                            content:[
                                {
                                    name:'Organiser Name: Raghav Juyal',
                                    mobile:'Mobile Number: 7899361585 '
                                },
                                {
                                    name:'Organiser Name: Srikaran Perambuduri',
                                    mobile:'Mobile Number: 9022752450'
                                },
                            ]
                        },

                    ]
                },

        },
            {
                name:'Art Attack',
                photo:ArtAttack,
                details:'Painting is not about what one sees but what one can make others see! This theme-based painting competition is an opportunity to bring your imagination and creativity together on the paper alive.',
                rules:'https://drive.google.com/file/d/1_lZMvS1zp59mEbTX5fZAk_qrYnBPFL7K/view',
                submit:'https://docs.google.com/forms/d/e/1FAIpQLSdTtkmvg1KTfPD8FOPzHfda9pTHE7BUYTahgvyKRwHMlk9FwQ/viewform',
                modal:{
                    name:'Art Attack',
                    data:[
                        {
                            name:'Rules and Regulations',
                            type:'list',
                            content:[
                                'This is a solo painting competition',
                                'The theme is : Childhood memories',
                                'The submissions should be sent via our website :\n' +
                                'https://elan.org.in/competitions',
                                'Only the submissions made through the website will be considered\n' +
                                'by the judges for evaluation',
                                'Bonus : You can also upload your entry on instagram with #elannvision and\n' +
                                '#elannvision2021, we will upload the top entries on our competitions page -\n' +
                                '@elan_nvision.competitions. If you have a private account, submit a\n' +
                                'screenshot of your post, atleast one hour after uploading it.',
                                'Bonus : You can also upload your entry on instagram with #elannvision and\n' +
                                '#elannvision2021, we will upload the top entries on our competitions page -\n' +
                                '@elan_nvision.competitions. If you have a private account, submit a\n' +
                                'screenshot of your post, atleast one hour after uploading it.',
                                'Bonus : You can also upload your entry on instagram with #elannvision and\n' +
                                '#elannvision2021, we will upload the top entries on our competitions page -\n' +
                                '@elan_nvision.competitions. If you have a private account, submit a\n' +
                                'screenshot of your post, atleast one hour after uploading it.',
                                'The selected submissions will be showcased in an online exhibition and the\n' +
                                'winners will be announced on our instagram page and will also be informed\n' +
                                'through mail.',
                                'Only 1 entry is allowed per participant.',
                                'There is no restriction on the medium or paper used.',
                                'Participants are not allowed to take reference from any digital or printed\n' +
                                'picture. Failure to follow this will lead to disqualification.',
                                'Use of explicit content, references or unfair means is not allowed and if not\n' +
                                'adhered to, will lead to disqualification.',
                                'Plagiarism is strictly prohibited.',
                                'The decision of the judges and the organizers is final and abiding.',
                                'The organising team has the complete right to change the prize money if the\n' +
                                'participation is less than ten.',
                                'The organizing team has the right to change any or all the rules mentioned\n' +
                                'above.',
                            ]

                        },
                        {
                            name:'Timeline',
                            type:'list',
                            content:[
                                'Submission deadline - March 8th, 11:59pm',
                                'Poster release - 26th February, 2021',
                                'Event date - 12th March, 2021',
                            ]
                        },
                        {
                            name:'Prizes',
                            type:'list',
                            content:[
                                'All the participants will receive an E-certificate of participation by Elan and\n' +
                                'Nvision , IIT Hyderabad.',
                                'Prizes worth ₹10,000 are up for grabs',
                            ]
                        },
                        {
                            name:'Judging criteria',
                            type:'list',
                            content:[
                                'Creativity',
                                'Theme incorporation',
                                'Colour scheme',
                                'Finishing',
                                'Overall impact',
                            ]
                        },
                        {
                            name:'Contact Details',
                            type:'contact',
                            content:[
                                {
                                    name:'Sri Varshitha Manduri',
                                    mobile:'9154619754',
                                },
                                {
                                    name:'Stephen V S',
                                    mobile:'8136938412',
                                }
                            ]
                        },

                    ]
                }

            },
            {
                name:'Breakfree',
                photo:Breakfree,
                details:'Is dancing your passion? Does the zen of dance breath life into your torrid day? This is where you can show off your moves to the masses and shine. It is one of the biggest and most glamorous events of the fest. Participants can perform any dance form (except classical).\n',
                rules:'https://drive.google.com/file/d/1qhkpT-GlQ57R4fCx3gvxS0oJvmd8FcDW/view',
                submit:'https://docs.google.com/forms/d/e/1FAIpQLScFlan8TWmR59P35jyky_2WiOazJyEPd_fuTqfUQvY0ZRFZxg/viewform',
                modal:{
                    sp1:SBI,
                    name:'Breakfree',
                    link:'https://www.airmeet.com/e/0067bec0-80bf-11eb-832c-3d4227c65b45',
                    data:[
                        {
                            name:'Rules and Regulations',
                            type:'list',
                            content:[
                                'This is a solo dance competition',
                                'There will be only one round',
                                'The submissions should be sent via our website :\n' +
                                'https://elan.org.in/competitions',
                                'Only the submissions made through the website will be considered\n' +
                                'by the judges for evaluation',
                                'Bonus : You can also upload your entry on instagram with #elannvision and\n' +
                                '#elannvision2021, we will upload the top entries on our competitions page -\n' +
                                '@elan_nvision.competitions. If you have a private account, submit a\n' +
                                'screenshot of your post, atleast one hour after uploading it.',
                                'The selected submissions will be streamed on a video-conferencing app and will be evaluated live by the judges',
                                'The list of participants selected will be sent to all the participants through email.\n',
                                'Only 1 entry is allowed per participant.',
                                'The duration of the performance should be 1.5-3 mins.\n',
                                'All styles are accepted except classical.\n',
                                'The use of props is allowed.',
                                'Songs containing vulgar or explicit lyrics will not be allowed. Contestants who perform in an obscene or vulgar manner will be disqualified from the competition.\n',
                                'The video cannot be edited or have any special effects added to it.',
                                'The decision of the organizers and judges shall be final and binding.',
                                'The organising team has the complete right to change the prize money if the participation is less than ten.',
                                'The organizing team has the right to change any or all the rules mentioned above.',
                            ]

                        },
                        {
                            name:'Timeline',
                            type:'list',
                            content:[
                                'Submission deadline - March 8th, 11:59pm',
                                'Poster release - 16th February, 2021',
                                'Event date - 12th March, 2021',
                            ]
                        },
                        {
                            name:'Prizes',
                            type:'list',
                            content:[
                                'All the participants will receive an E-certificate of participation by Elan and\n' +
                                'Nvision , IIT Hyderabad.',
                                'Prizes worth ₹15,000 are up for grabs',
                            ]
                        },
                        {
                            name:'Judging criteria',
                            type:'list',
                            content:[
                                'Creativity',
                                'Choreography',
                                'Energy',
                                'Difficulty of Execution\n',
                                'Attire',
                                'Music Mix',
                            ]
                        },
                        {
                            name:'Contact Details',
                            type:'contact',
                            content:[
                                {
                                    name:'KN Vardhan',
                                    mobile:'9652793113',
                                },
                                {
                                    name:'Shraddha ',
                                    mobile:'6301917276',
                                }
                            ]
                        },

                    ]
                }
            },
            {
                name:'Campus Idol',
                photo:CampusIdol,
                details:'When your passion is singing , nothing can stop you from bringing your music to life. Campus Idol is the perfect platform to help you share love and happiness through your song!',
                rules:'https://drive.google.com/file/d/1PH-O04OZ__Nt2DbnkbAKqe1-hSIzwEfa/view',
                submit:'https://docs.google.com/forms/d/e/1FAIpQLSdp14pIndxxJz5n4UglgbJf54FeE3rtLHSwiLTKTC0MO-vqNA/viewform',
                modal:{
                    sp1:UnionBank,
                    sp2:Chromatics,
                    name:'Campus Idol',
                    link:'https://www.airmeet.com/e/56a1ff60-810c-11eb-be52-8bc071da5c32',

                    data:[
                        {
                            name:'Rules and Regulations',
                            type:'list',
                            content:[
                                'This is a solo singing competition',
                                'There will be only one round',
                                'The submissions should be sent via our website :\n' +
                                'https://elan.org.in/competitions',
                                'Only the submissions made through the website will be considered\n' +
                                'by the judges for evaluation',
                                'Bonus : You can also upload your entry on instagram with #elannvision and\n' +
                                '#elannvision2021, we will upload the top entries on our competitions page -\n' +
                                '@elan_nvision.competitions. If you have a private account, submit a\n' +
                                'screenshot of your post, atleast one hour after uploading it.',
                                'The selected submissions will be streamed on a video-conferencing app and will be evaluated live by the judges',
                                'The list of participants selected will be sent to all the participants through email.\n',
                                'Only 1 entry is allowed per participant.',
                                'The duration of the performance should be 1.5-3 mins.\n',
                                'The languages preferred are English, Hindi, and Telugu\n',
                                'Participants can have a karaoke track or play an accompanying instrument and are also allowed to have an instrumentalist accompanist(maximum of 2). ',
                                'Backing vocals are not allowed. Participants exceeding the prescribed time limit will invite a penalty.',
                                'Rapping is not allowed\n',
                                'Songs containing vulgar or explicit lyrics will not be allowed. Contestants who, during their performance, use vulgar lyrics or perform in an obscene manner will be disqualified from the competition\n',
                                'The audio cannot be processed after recording.\n',
                                'The video cannot be edited or have any special effects added to it\n',
                                'The decision of the judges and the organizers is final and abiding.',
                                'The organising team has the complete right to change the prize money if the participation is less than ten.',
                                'The organizing team has the right to change any or all the rules mentioned above.',
                            ]

                        },
                        {
                            name:'Timeline',
                            type:'list',
                            content:[
                                'Submission deadline - March 8th, 11:59pm',
                                'Poster release - 22th February, 2021',
                                'Event date - 13th March, 2021',
                            ]
                        },
                        {
                            name:'Prizes',
                            type:'list',
                            content:[
                                'All the participants will receive an E-certificate of participation by Elan and\n' +
                                'Nvision , IIT Hyderabad.',
                                'Prizes worth ₹15,000 are up for grabs',
                            ]
                        },
                        {
                            name:'Judging criteria',
                            type:'list',
                            content:[
                                'Vocal ability',
                                'Overall Impact',
                                'Pitch',
                                'Rythm',
                            ]
                        },
                        {
                            name:'Contact Details',
                            type:'contact',
                            content:[
                                {
                                    name:'Adithya Ram',
                                    mobile:'7670934896',
                                },
                                {
                                    name:'Satwik Arawalli',
                                    mobile:'8217435039',
                                },
                                {
                                    name:'Varunaditya Singhal',
                                    mobile:'7015715920',
                                }
                            ]
                        },

                    ]
                }
            },//14
            {
                name:'Doodle Art',
                photo:DoodleArt,
                details:'Doodling is a fun way of expressing yourself! It is not just a stress buster but also unlocks the subconscious creativity within you. In these times of pandemic , the elan & nvision is here to your rescue with its very own doodle art competition! Get ready to show off your doodles !\n',
                rules:'https://drive.google.com/file/d/1YqNBlHFJ1-D2mw-H0qfSvh6I74iYWd_o/view',
                submit:'https://docs.google.com/forms/d/e/1FAIpQLScgcAWBy1_QTUy9ucn3y9sg-NrQG-A2udEKle6KWulFg2L98A/viewform',
                modal:{
                    name:'Doodle Art',
                    data:[
                        {
                            name:'Rules and Regulations',
                            type:'list',
                            content:[
                                'This is a solo doodle creation competition',
                                'The theme is : Childhood memories',
                                'The submissions should be sent via our website :\n' +
                                'https://elan.org.in/competitions',
                                'Only the submissions made through the website will be considered\n' +
                                'by the judges for evaluation',
                                'Bonus : You can also upload your entry on instagram with #elannvision and\n' +
                                '#elannvision2021, we will upload the top entries on our competitions page -\n' +
                                '@elan_nvision.competitions. If you have a private account, submit a\n' +
                                'screenshot of your post, atleast one hour after uploading it.',
                                'The participant also has to upload three photos showing him/her during the painting process : one at the start, one in the middle and one at the end in the google form. A 20-40 sec video should also be uploaded in the google form showing the participant while painting. Note that the artwork and the participant should be clearly visible in all of these.\n',
                                'The list of participants selected will be sent to all the participants through email.',
                                'The selected submissions will be showcased in an online exhibition and the\n' +
                                'winners will be announced on our instagram page and will also be informed\n' +
                                'through mail.',
                                'Only 1 entry is allowed per participant.',
                                'The entry must be a free hand doodle.',
                                'Entry must not be derogatory, offensive, threatening or defamatory, else it will be disqualified.\n',
                                'Plagiarism is strictly prohibited.',
                                'The decision of the judges and the organizers is final and abiding.',
                                'The organising team has the complete right to change the prize money if the\n' +
                                'participation is less than ten.',
                                'The organizing team has the right to change any or all the rules mentioned\n' +
                                'above.',
                            ]

                        },
                        {
                            name:'Timeline',
                            type:'list',
                            content:[
                                'Submission deadline - March 8th, 11:59pm',
                                'Poster release - 26th February, 2021',
                                'Event date - 13th March, 2021',
                            ]
                        },
                        {
                            name:'Prizes',
                            type:'list',
                            content:[
                                'All the participants will receive an E-certificate of participation by Elan and\n' +
                                'Nvision , IIT Hyderabad.',
                                'Prizes worth ₹8,000 are up for grabs',
                            ]
                        },
                        {
                            name:'Judging criteria',
                            type:'list',
                            content:[
                                'Creativity',
                                'Drawing skills and use of colour',
                                'Originality',
                            ]
                        },
                        {
                            name:'Contact Details',
                            type:'contact',
                            content:[
                                {
                                    name:'Arpita Gautam',
                                    mobile:'9326519305',
                                },
                                {
                                    name:'Vikhyath',
                                    mobile:'7708711549',
                                }
                            ]
                        },

                    ]
                }
            },
            {
                name:' Filmfare Fiesta',
                photo:FilmfareFiesta,
                details:'Do you think you can take after Steven Spielberg, Christopher Nolan and James Cameron? Make your own short film, enthral and captivate movie buffs with your creativity. The stage at Elan & ηvision 2021 is set for you. Get judged by esteemed people in the film industry',
                rules:'https://drive.google.com/file/d/138qcrwNublE3VCVHO6M2Uk3E9W3NInZc/view',
                submit:'https://docs.google.com/forms/d/e/1FAIpQLSd2ms5QJEaPBTNW4OkXRUPTEi8t5EPDUYWB9flNUn47tFPsqg/viewform?usp=sf_link',
                modal:{
                    sp1:TalingTimber,
                    name:'Filmfare Fiesta',
                    link:'https://www.airmeet.com/e/9c5531f0-80bf-11eb-a0b5-4bad1a43778e',
                    data:[
                        {
                            name:'Rules and Regulations',
                            type:'list',
                            content:[
                                'This is a short film making competition',
                                'There will be only one round\n',
                                'The submissions should be sent via our website :\n' +
                                'https://elan.org.in/competitions',
                                'Only the submissions made through the website will be considered\n' +
                                'by the judges for evaluation',
                                'Bonus : You can also upload your entry on instagram with #elannvision and\n' +
                                '#elannvision2021, we will upload the top entries on our competitions page -\n' +
                                '@elan_nvision.competitions. If you have a private account, submit a\n' +
                                'screenshot of your post, atleast one hour after uploading it.',
                                'The selected submissions will be showcased in an online exhibition and the\n' +
                                'winners will be announced on our instagram page and will also be informed\n' +
                                'through mail.',
                                'At least one member from each team should be present while the judgement is taking place.\n',
                                'Movies should be shot at a minimum resolution of 480 pixels. Marks might be reduced due to poor video/ audio quality.',
                                'Sound tracks (no max time limit) and stock footage (time limit : max of 1 min 30 seconds) can be borrowed, but with due credits.',
                                'Films in languages other than English, Hindi, and Telugu should be accompanied with subtitles.',
                                'Entries must be the original work of the entrant.\n',
                                'Any attempt at copyright infringement can lead to immediate disqualification.\n',
                                'The content of the movie should be appropriate for public screening and thus have no vulgarity. Obscenity (at the discretion of the judges) of any kind is not allowed and will lead to immediate disqualification.\n',
                                'Plagiarism is strictly prohibited.',
                                'The list of participants selected will be sent to all the participants through email.\n',
                                'Team Size: At most 15 in the core team(No particular limit for actors in the film)',
                                'Only 1 entry is allowed per participant.',
                                'Run time should not be more than 20 minutes\n',
                                'The decision of the judges and the organizers is final and abiding.',
                                'The organising team has the complete right to change the prize money if the\n' +
                                'participation is less than ten.',
                                'The organizing team has the right to change any or all the rules mentioned\n' +
                                'above.',
                            ]

                        },
                        {
                            name:'Timeline',
                            type:'list',
                            content:[
                                'Submission deadline - March 8th, 11:59pm',
                                'Poster release - 18th February, 2021',
                                'Event date - 14th March, 2021',
                            ]
                        },
                        {
                            name:'Prizes',
                            type:'list',
                            content:[
                                'All the participants will receive an E-certificate of participation by Elan and\n' +
                                'Nvision , IIT Hyderabad.',
                                'Prizes worth ₹12,000 are up for grabs',
                            ]
                        },
                        {
                            name:'Judging criteria',
                            type:'list',
                            content:[
                                'Script (Originality)',
                                'Direction',
                                'Screenplay',
                                'Acting',
                                'Cinematography',
                                'Sound editing/ mixing',
                                'Visual effects\n',
                                'Costumes',
                                'Dialogues',
                            ]
                        },
                        {
                            name:'Contact Details',
                            type:'contact',
                            content:[
                                {
                                    name:'Srikaran Perambuduri',
                                    mobile:'9022752450',
                                },
                                {
                                    name:'Poorvika ',
                                    mobile:'9900810774',
                                }
                            ]
                        },

                    ]
                }
            },
            {
                name:'Glitz & Glamour',
                photo:Glitz,
                details:'Modelling is not just about beauty, it is about the way you portray yourself with confidence and glamour yet keeping simplicity in you alive! A platform for all those young ladies out there who always dreamt of being a model. Elan & ηvision 2021 gives you the opportunity to take the first step towards your passion .',
                rules:'https://drive.google.com/file/d/1B7Ub0lELWzT1J2qCrvmueeekp24nowxU/view',
                submit:'https://docs.google.com/forms/d/e/1FAIpQLSeXbP7HWxHjTqdyXkmmlq73u_oQoADf8Y_KNBJdndAMVthsVg/viewform',
                modal:{
                    name:'Glitz & Glamour',
                    link:'https://www.airmeet.com/e/05aa38d0-80c0-11eb-8852-cd2c54167cf2',
                    data:[
                        {
                            name:'Rules and Regulations',
                            type:'list',
                            content:[
                                'This is a modelling  competition',
                                'There will be two rounds : 1. Walk the ramp and 2. Interview',
                                'The applicant should follow the dress code of a black cocktail dress while walking the ramp(preferably with stilettos)\n',
                                'Participants need to submit a recording of their ramp walk through our website : https://elan.org.in/competitions',
                                'Only the submissions made through the website will be considered\n' +
                                'by the judges for evaluation',
                                'Bonus : You can also upload your entry on instagram with #elannvision and\n' +
                                '#elannvision2021, we will upload the top entries on our competitions page -\n' +
                                '@elan_nvision.competitions. If you have a private account, submit a\n' +
                                'screenshot of your post, atleast one hour after uploading it.',
                                'The selected participants will have an interview round with the judges, which will be streamed live on a video-conferencing app.',
                                'The selected submissions will be showcased in an online exhibition and the\n' +
                                'winners will be announced on our instagram page and will also be informed\n' +
                                'through mail.',
                                'Only 1 entry is allowed per participant.',
                                'The duration of the video should be 1 minute at max',
                                'The recording must have clarity and the lighting must be apt.',
                                'The video cannot be edited or have any special effects added to it.\n',
                                'The decision of the judges and the organizers is final and abiding.',
                                'The organising team has the complete right to change the prize money if the\n' +
                                'participation is less than ten.',
                                'The organizing team has the right to change any or all the rules mentioned\n' +
                                'above.',
                            ]

                        },
                        {
                            name:'Timeline',
                            type:'list',
                            content:[
                                'Submission deadline - March 8th, 11:59pm',
                                'Poster release - 20th February, 2021',
                                'Event date - 14th March, 2021',
                            ]
                        },
                        {
                            name:'Prizes',
                            type:'list',
                            content:[
                                'All the participants will receive an E-certificate of participation by Elan and\n' +
                                'Nvision , IIT Hyderabad.',
                                'Prizes worth ₹12,000 are up for grabs',
                            ]
                        },
                        {
                            name:'Judging criteria',
                            type:'list',
                            content:[
                                'Body language',
                                'Confidence',
                                'Attention to detail with accessories\n',
                                'Appreciation of current fashion trends',
                                'Grooming ',
                            ]
                        },
                        {
                            name:'Contact Details',
                            type:'contact',
                            content:[
                                {
                                    name:'K Ananya',
                                    mobile:'8790449627',
                                },
                                {
                                    name:'Nikhil ',
                                    mobile:'9492476086',
                                },
                                {
                                    name:'Shreyansh Agarwal ',
                                    mobile:'8979471587'
                                }
                            ]
                        },

                    ]
                }
            },
            {
                name:'Nrityanjali',
                photo:Nrityanjali,
                details:'Classical dance is the fusion of the mind\'s emotions and the body\'s articulate movements. It takes the viewers to a completely different world of calmness and imagination. Every  performance unfolds a new story! We, at elan invite you to celebrate the beauty of Indian classical dance. Come and mesmerise the audience with your grace, expressions and soulful talent!',
                rules:'https://drive.google.com/file/d/1YBmwA9-1GG5ICQaai3x1QMJzH0eqYCzr/view',
                submit:'https://docs.google.com/forms/d/e/1FAIpQLScLl5O8wXqhg0a0pGFmvMBemWQxcMcme97LIw3cw_kLO2GeWA/viewform?usp=sf_link',
                modal:{
                    sp1:LIC,
                    name:'Nrityanjali',
                    link:'https://www.airmeet.com/e/6a53c7d0-7ff6-11eb-9d02-0dd6bd89460e',
                    data:[
                        {
                            name:'Rules and Regulations',
                            type:'list',
                            content:[
                                'This is a solo classical dance competition',
                                'There will be only one round\n',
                                'The submissions should be sent via our website :\n' +
                                'https://elan.org.in/competitions',
                                'Only the submissions made through the website will be considered\n' +
                                'by the judges for evaluation',
                                'Bonus : You can also upload your entry on instagram with #elannvision and\n' +
                                '#elannvision2021, we will upload the top entries on our competitions page -\n' +
                                '@elan_nvision.competitions. If you have a private account, submit a\n' +
                                'screenshot of your post, atleast one hour after uploading it.',
                                'The selected submissions will be streamed on a video-conferencing app and will be evaluated live by the judges',
                                'Only 1 entry is allowed per participant.',
                                'The duration of the performance should be 4-7 minutes',
                                'Anyone exceeding this time limit will get a penalty of points.\n',
                                'You can perform in any Indian classical dance form (we\'d love to see Bharatanatyam, Kuchipudi, Odissi, Mohiniyattam and others). However there are no separate judging categories for the different forms.\n',
                                'Semi-classical / Classical Bollywood songs are not allowed.',
                                'Live music is also not allowed.',
                                'There will be a small weightage for costumes. Dance should consist of both Nritya and Abhinaya.',
                                'Points will be awarded for rhythm, choice of song and dance, expression, costumes and synchronization.',
                                'This competition is open to all age groups.',
                                'The song must be clearly audible in the video. Also the recording must be taken in good lighting and with clarity.',
                                'Songs containing vulgar or explicit lyrics will not be allowed. Contestants who perform in an obscene or vulgar manner will be disqualified from the competition.',
                                'The video cannot be edited or have any special effects added to it.\n',
                                'The decision of the judges and the organizers is final and abiding.',
                                'The organising team has the complete right to change the prize money if the\n' +
                                'participation is less than ten.',
                                'The organizing team has the right to change any or all the rules mentioned\n' +
                                'above.',
                            ]

                        },
                        {
                            name:'Timeline',
                            type:'list',
                            content:[
                                'Submission deadline - March 8th, 11:59pm',
                                'Poster release - 14th February, 2021',
                                'Event date - 11th March, 2021',
                            ]
                        },
                        {
                            name:'Prizes',
                            type:'list',
                            content:[
                                'All the participants will receive an E-certificate of participation by Elan and\n' +
                                'Nvision , IIT Hyderabad.',
                                'Prizes worth ₹15,000 are up for grabs',
                            ]
                        },
                        {
                            name:'Judging criteria',
                            type:'list',
                            content:[
                                'Rhythm',
                                'Choreography',
                                'Footwork',
                                'Selection of music piece',
                                'Expressions and body language\n',
                                'Costume and presentation',
                                'Overall Clarity and Impact',
                            ]
                        },
                        {
                            name:'Contact Details',
                            type:'contact',
                            content:[
                                {
                                    name:'K Madhumitha',
                                    mobile:'8309567379',
                                },
                                {
                                    name:'B Vishal Datta',
                                    mobile:'7670925438',
                                }
                            ]
                        },

                    ]
                }
            },
            {
                name:'Picelectic',
                photo:Picelectric,
                details:'Photography is the best way to capture a moment and save it forever! It is an austere and blazing poetry of the real. So, keep your camera ready to capture the perfect moment and show us your talent!\n',
                rules:'https://drive.google.com/file/d/1zQqoPrAvfH1cqr1VvDf3AKFYZw6SWy1j/view',
                submit:'https://docs.google.com/forms/d/e/1FAIpQLSfm-O8HHt88lxXrfIisOMgBaLrzEtqqtmnzi-YiKBi_WECcAg/viewform',
                modal:{
                    name:'Picelectic',
                    data:[
                        {
                            name:'Rules and Regulations',
                            type:'list',
                            content:[
                                'This is a photography  competition',
                                'There will be only one round',
                                'The submissions should be sent via our website :\n' +
                                'https://elan.org.in/competitions',
                                'Only the submissions made through the website will be considered\n' +
                                'by the judges for evaluation',
                                'Bonus : You can also upload your entry on instagram with #elannvision and\n' +
                                '#elannvision2021, we will upload the top entries on our competitions page -\n' +
                                '@elan_nvision.competitions. If you have a private account, submit a\n' +
                                'screenshot of your post, atleast one hour after uploading it.',
                                'The selected submissions will be showcased in an online exhibition and the\n' +
                                'winners will be announced on our instagram page and will also be informed\n' +
                                'through mail.',
                                'Only 1 entry is allowed per participant.',
                                'The pics must be taken only using a Digi-cam or a Bluetooth enabled mobile .',
                                'Winner is judged according to the moments captured in the best way.',
                                'There is no theme restriction',
                                'Plagiarism is strictly prohibited.',
                                'The decision of the judges and the organizers is final and abiding.',
                                'The organising team has the complete right to change the prize money if the\n' +
                                'participation is less than ten.',
                                'The organizing team has the right to change any or all the rules mentioned\n' +
                                'above.',
                            ]

                        },
                        {
                            name:'Timeline',
                            type:'list',
                            content:[
                                'Submission deadline - March 8th, 11:59pm',
                                'Poster release - 18th February, 2021',
                                'Event date - 12th March, 2021',
                            ]
                        },
                        {
                            name:'Prizes',
                            type:'list',
                            content:[
                                'All the participants will receive an E-certificate of participation by Elan and\n' +
                                'Nvision , IIT Hyderabad.',
                                'Prizes worth ₹10,000 are up for grabs',
                            ]
                        },
                        {
                            name:'Judging criteria',
                            type:'list',
                            content:[
                                'Creativity',
                                'Impact',
                                'Composition',
                            ]
                        },
                        {
                            name:'Contact Details',
                            type:'contact',
                            content:[
                                {
                                    name:'Tanmay Shah',
                                    mobile:'9370294588',
                                },
                                {
                                    name:'Yash Rajput',
                                    mobile:'9752334968',
                                }
                            ]
                        },

                    ]
                }
            },//19
            {
                name:'Stand Up',
                photo:Standup,
                details:'Comedy has long captured the awe of the masses and stand up is the modern rage. Can you enthrall the audience with your wacky humour? Can you brighten up someone’s day? This is the event where you can test your skills against other similarly talented folk and try to come out on top.',
                rules:'https://drive.google.com/file/d/1AQX_w_RV-1nrcKqm0mfS-Gv__-JSwJyT/view',
                submit:'https://docs.google.com/forms/d/e/1FAIpQLSevg1Umswr6pKgqYaAUJ8YcmSeSfXWU40zWvIy3wkPpTKszGg/viewform?usp=sf_link',
                modal:{
                    name:'Stand Up',
                    link:'https://www.airmeet.com/e/d39a3660-80bf-11eb-8941-a93b2235faef',
                    data:[
                        {
                            name:'Rules and Regulations',
                            type:'list',
                            content:[
                                'This is a solo competition',
                                'There will be only one round',
                                'The submissions should be sent via our website :\n' +
                                'https://elan.org.in/competitions',
                                'Only the submissions made through the website will be considered\n' +
                                'by the judges for evaluation',
                                'Bonus : You can also upload your entry on instagram with #elannvision and\n' +
                                '#elannvision2021, we will upload the top entries on our competitions page -\n' +
                                '@elan_nvision.competitions. If you have a private account, submit a\n' +
                                'screenshot of your post, atleast one hour after uploading it.',
                                'The selected submissions will be streamed on a video-conferencing app and will be evaluated live by the judges',
                                'Only 1 entry is allowed per participant.',
                                'The duration of the act should be 3-5 mins',
                                'The act must be in English, Hindi or Telugu\n',
                                'The performance could either be a \'mono-act\', or a \'stand-up comedy\', or both',
                                'Time limit should be strictly followed, failing which there will be deduction in your respective score',
                                'The video should not be edited in any way. Use of any kind of special effects is STRICTLY prohibited and will lead to direct disqualification',
                                'The decision of the judges and the organizers is final and abiding.',
                                'The organising team has the complete right to change the prize money if the\n' +
                                'participation is less than ten.',
                                'The organizing team has the right to change any or all the rules mentioned\n' +
                                'above.',
                            ]

                        },
                        {
                            name:'Timeline',
                            type:'list',
                            content:[
                                'Submission deadline - March 8th, 11:59pm',
                                'Poster release - 24th February, 2021',
                                'Event date - 13th March, 2021',
                            ]
                        },
                        {
                            name:'Prizes',
                            type:'list',
                            content:[
                                'All the participants will receive an E-certificate of participation by Elan and\n' +
                                'Nvision , IIT Hyderabad.',
                                'Prizes worth ₹12,000 are up for grabs',
                            ]
                        },
                        {
                            name:'Judging criteria',
                            type:'list',
                            content:[
                                'Content',
                                'Quality of humor',
                                'Overall impact',
                            ]
                        },
                        {
                            name:'Contact Details',
                            type:'contact',
                            content:[
                                {
                                    name:'Rupin ',
                                    mobile:'7793916108',
                                },
                                {
                                    name:'Viren Soni',
                                    mobile:'7408070150',
                                },
                                {
                                    name:'K Praneeth Nayak',
                                    mobile:'9121663809'
                                }

                            ]
                        },

                    ]
                }
            },
            {
                name:'Plot The Twist',
                photo:PlotTwist,
                details:'It’s gotta be twisted\n' +
                    '\n' +
                    'It’s just gotta be HELLA twisted\n' +
                    '\n' +
                    'Here’s a short example:\n' +
                    '\n' +
                    '\n' +
                    'I like writing. A lot. But I\'ve been rejected by publishers way too many times. I\'m not yet published. But now I\'m writing my magnum opus. My Masterpiece. I\'ve taken lessons from GRR Martin to heart. To kill my characters one by one. I will do him one better. I hope my autobiography sells well.',
                rules:'https://drive.google.com/file/d/1AQX_w_RV-1nrcKqm0mfS-Gv__-JSwJyT/view',
                submit:'https://www.google.com/url?q=https://forms.gle/eN5eaYUJz1RAz82u6&sa=D&source=editors&ust=1615038334556000&usg=AOvVaw2Pu0ghStBXSQrJ2cjDalF2',
                modal:{
                    name:'Plot The Twist',
                    data:[
                        {
                            name:'Rules and Regulations',
                            type:'list',
                            content:[
                                'Word limit: 1200 words. It can be shorter than this if you like, but no longer.\n' ,
                                'The clincher : You necessarily MUST include at least one plot twist in your entire story.\n' ,
                                'Genre: Go wild! No preferred genre. Just make sure your story is gripping.\n',
                                'Plagiarism: Haha, no. Any form of unoriginality will  lead straight to disqualification.\n' ,
                                'Language: English and Hindi both languages will be accepted.'
                            ]

                        },
                        // {
                        //     name:'Timeline',
                        //     type:'list',
                        //     content:[
                        //         'Submission deadline - March 8th, 11:59pm',
                        //         'Poster release - 24th February, 2021',
                        //         'Event date - 13th March, 2021',
                        //     ]
                        // },
                        // {
                        //     name:'Prizes',
                        //     type:'list',
                        //     content:[
                        //         'All the participants will receive an E-certificate of participation by Elan and\n' +
                        //         'Nvision , IIT Hyderabad.',
                        //         'Prizes worth ₹12,000 are up for grabs',
                        //     ]
                        // },
                        // {
                        //     name:'Judging criteria',
                        //     type:'list',
                        //     content:[
                        //         'Content',
                        //         'Quality of humor',
                        //         'Overall impact',
                        //     ]
                        // },
                        {
                            name:'Contact Details',
                            type:'contact',
                            content:[
                                {
                                    name:'Satya Aditi Dhaaipule ',
                                    mobile:'9505695646',
                                },
                                {
                                    name:'Sidhant Ranka',
                                    mobile:'9586406788',
                                },
                                {
                                    name:'Sreevani Chikkalawar',
                                    mobile:'9063033777'
                                }

                            ]
                        },

                    ]
                }
            },
            {
                name:'Inked Verses',
                photo:InkedVerse,
                details:'If you stay lost in those fleeting events and unique memories, if you wish to outline curious imaginations with those tailored lines that serve a poetic hinge, this is the event for you. Compete in “Inked Verses”, our poetry competition and showcase your imagination!',
                rules:'https://drive.google.com/file/d/1AQX_w_RV-1nrcKqm0mfS-Gv__-JSwJyT/view',
                submit:'https://www.google.com/url?q=https://forms.gle/2Tq4mvdL9xWEtKoK9&sa=D&source=editors&ust=1615038334561000&usg=AOvVaw0KcyKyStqxrl-vLr2cPmSy',
                modal:{
                    name:'Inked Verses',
                    data:[
                        {
                            name:'Rules and Regulations',
                            type:'list',
                            content:[
                                'You are free to write poems in either English or Hindi, no more than 150 words.\n',
                                'There are no constraints on themes; the best entries come from creative yet meaningful stands.\n' ,
                                'Entries with racial/religious/sexual discrimination and/or offensive content won’t be tolerated and will lead to disqualification.\n' ,
                                'Plagiarism is strictly prohibited and will result in disqualification.',
                            ]

                        },
                        // {
                        //     name:'Timeline',
                        //     type:'list',
                        //     content:[
                        //         'Submission deadline - March 8th, 11:59pm',
                        //         'Poster release - 24th February, 2021',
                        //         'Event date - 13th March, 2021',
                        //     ]
                        // },
                        // {
                        //     name:'Prizes',
                        //     type:'list',
                        //     content:[
                        //         'All the participants will receive an E-certificate of participation by Elan and\n' +
                        //         'Nvision , IIT Hyderabad.',
                        //         'Prizes worth ₹12,000 are up for grabs',
                        //     ]
                        // },
                        // {
                        //     name:'Judging criteria',
                        //     type:'list',
                        //     content:[
                        //         'Content',
                        //         'Quality of humor',
                        //         'Overall impact',
                        //     ]
                        // },
                        {
                            name:'Contact Details',
                            type:'contact',
                            content:[
                                {
                                    name:'Anish Ambavat',
                                    mobile:'9967939300',
                                },
                                {
                                    name:'Gowri Govindaraj',
                                    mobile:'8075887986',
                                },
                                {
                                    name:'Tejash Agrahari',
                                    mobile:'9651180408'
                                }

                            ]
                        },

                    ]
                }
            },
            {
                name:'Two Line Terror',
                photo:TLT,
                details:'Unleash the evil within you to the world in the scariest way you can: in under two lines! Give us your uncanniest stories in the most compact format. The most twisted two-liners are what we seek. Give us all you’ve got, we don\'t scare easy (2020 made sure of that)!',
                rules:'https://drive.google.com/file/d/1AQX_w_RV-1nrcKqm0mfS-Gv__-JSwJyT/view',
                submit:'https://www.google.com/url?q=https://forms.gle/NsQFYk23JsFnTE9LA&sa=D&source=editors&ust=1615038334565000&usg=AOvVaw104xz66Rs5Ri0AKJUyC1Ji',
                modal:{
                    name:'Two Line Terror',
                    data:[
                        {
                            name:'Rules and Regulations',
                            type:'list',
                            content:[
                                'All entries must be two sentences or less.The shorter, the scarier, the better.\n' ,
                                'The entry should focus solely on the story. We don’t want to know how that one youtube video or reddit post inspired you to write this. Get to the point. \n',
                                'Your composition should be standalone, that is, it shouldn\'t refer to other popular works.\n',
                                'Don\'t hold back, make it spooky. Go on, even the devil was an angel once.\n' ,
                                'Do not copy worthy compositions. Instead, create copy-worthy material.\n',
                                'Make sure your stories are scary, not creepy. That means no lewd remarks about or allusions to sensitive societal topics. No one likes to read something only to get offended by it. So offensive content is a BIG no-no. Stay woke.'
                            ]

                        },
                        // {
                        //     name:'Timeline',
                        //     type:'list',
                        //     content:[
                        //         'Submission deadline - March 8th, 11:59pm',
                        //         'Poster release - 24th February, 2021',
                        //         'Event date - 13th March, 2021',
                        //     ]
                        // },
                        // {
                        //     name:'Prizes',
                        //     type:'list',
                        //     content:[
                        //         'All the participants will receive an E-certificate of participation by Elan and\n' +
                        //         'Nvision , IIT Hyderabad.',
                        //         'Prizes worth ₹12,000 are up for grabs',
                        //     ]
                        // },
                        // {
                        //     name:'Judging criteria',
                        //     type:'list',
                        //     content:[
                        //         'Content',
                        //         'Quality of humor',
                        //         'Overall impact',
                        //     ]
                        // },
                        {
                            name:'Contact Details',
                            type:'contact',
                            content:[
                                {
                                    name:'Tata Prasanth',
                                    mobile:'9100546812',
                                },
                                {
                                    name:'Srivatsan T',
                                    mobile:'8610593033',
                                },


                            ]
                        },

                    ]
                }
            },
            {
                name:'Just Kidding',
                photo:JustKidding,
                details:'We all have that one embarrassing photo from our childhood which makes you wish that things played out a little differently, or a photo taken after an amazing moment which you hold very dear and replay in your head over and over again.\n' +
                    '\n' +
                    'Spin a tale from that one photo, and hey guess what, it doesn’t even have to be the truth!\n' +
                    '\n' +
                    'Retell the story of that particular moment; either exactly how it happened, or how you wish it happened. Pour out all your emotions through this story and be as creative as possible!',
                rules:'https://drive.google.com/file/d/1AQX_w_RV-1nrcKqm0mfS-Gv__-JSwJyT/view',
                submit:'https://www.google.com/url?q=https://forms.gle/1RgWyLxHbqRbuQvw5&sa=D&source=editors&ust=1615038334570000&usg=AOvVaw2-v41FpdItG-oNDnvAI6mX',
                modal:{
                    name:'Just Kidding',
                    data:[
                        {
                            name:'Rules and Regulations',
                            type:'list',
                            content:[
                                'The photo should be in its purest form: no edits, no filters.\n',
                                'You MUST be younger than 13 years old in the photo.\n' ,
                                'Word limit: around 500.\n',
                                'Plagiarism is not cool.\n' ,
                                'And brownie points! Upload your photo and story on Instagram and tag @elan_nvision.iith and @litsoc_iith with #elanlitfest . If the public likes it, you get a few extra points. We always like a bit of democracy helping us in our dictatorship.'
                            ]

                        },
                        // {
                        //     name:'Timeline',
                        //     type:'list',
                        //     content:[
                        //         'Submission deadline - March 8th, 11:59pm',
                        //         'Poster release - 24th February, 2021',
                        //         'Event date - 13th March, 2021',
                        //     ]
                        // },
                        // {
                        //     name:'Prizes',
                        //     type:'list',
                        //     content:[
                        //         'All the participants will receive an E-certificate of participation by Elan and\n' +
                        //         'Nvision , IIT Hyderabad.',
                        //         'Prizes worth ₹12,000 are up for grabs',
                        //     ]
                        // },
                        // {
                        //     name:'Judging criteria',
                        //     type:'list',
                        //     content:[
                        //         'Content',
                        //         'Quality of humor',
                        //         'Overall impact',
                        //     ]
                        // },
                        {
                            name:'Contact Details',
                            type:'contact',
                            content:[
                                {
                                    name:'\n' +
                                        'Teerth Raval',
                                    mobile:'70204 26653',
                                },
                                {
                                    name:'Amulya Tallamraju',
                                    mobile:'93464 01083',
                                },
                                {
                                    name:'Sreevani Chikkalawar',
                                    mobile:'9063033777'
                                }

                            ]
                        },

                    ]
                }
            },//24
            {
                name:'\n' +
                    'My Heartthrob',
                photo:MyHearthrob,
                details:'Your heartthrob: be it the lover who stole your heart, or the crush you want to see multiple times a day, everyday.\n' +
                    '\n' +
                    'Have your own Raj-Anjali or Romeo-Juliet story? Or maybe a failed love story? Or even just a crush? Express all your love and affection in this event and write your heart out. Gush about your perfectly imperfect romance. As long as it’s romantic and sufficiently lovey-dovey, we’ll take it ;)',
                rules:'https://drive.google.com/file/d/1AQX_w_RV-1nrcKqm0mfS-Gv__-JSwJyT/view',
                submit:'https://www.google.com/url?q=https://forms.gle/YpA4mWgeVUb17MVA6&sa=D&source=editors&ust=1615038334574000&usg=AOvVaw0rq1Sj1UpQjBdW7eZSpALx',
                modal:{
                    name:'\n' +
                        'My Heartthrob',
                    data:[
                        {
                            name:'Rules and Regulations',
                            type:'list',
                            content:[
                                'Four letters of LOVE can depict infinite words, but we would really appreciate it if you would restrict to 800 words.\n',
                                'Plagiarism is strictly not entertained and could lead to disqualification.\n',
                                'Feelings have no language. We\'ll accept all entries in English, Hindi (or even Hinglish).\n',
                                'Love has no boundaries but please refrain yourselves from using real names of people, and even if you do, be careful about sensitive topics. Also refrain from making insensitive remarks or using abuse and foul language of any form. It will lead straight to disqualification.\n',
                                'Your tales need not be original, fantasies of your love and feelings you want to sense are welcome.'
                            ]

                        },
                        // {
                        //     name:'Timeline',
                        //     type:'list',
                        //     content:[
                        //         'Submission deadline - March 8th, 11:59pm',
                        //         'Poster release - 24th February, 2021',
                        //         'Event date - 13th March, 2021',
                        //     ]
                        // },
                        // {
                        //     name:'Prizes',
                        //     type:'list',
                        //     content:[
                        //         'All the participants will receive an E-certificate of participation by Elan and\n' +
                        //         'Nvision , IIT Hyderabad.',
                        //         'Prizes worth ₹12,000 are up for grabs',
                        //     ]
                        // },
                        // {
                        //     name:'Judging criteria',
                        //     type:'list',
                        //     content:[
                        //         'Content',
                        //         'Quality of humor',
                        //         'Overall impact',
                        //     ]
                        // },
                        {
                            name:'Contact Details',
                            type:'contact',
                            content:[
                                {
                                    name:'Satya Aditi Dhaaipule',
                                    mobile:'9505695646',
                                },
                                {
                                    name:'Sidhant Ranka',
                                    mobile:'9586406788',
                                },
                                {
                                    name:'Sreevani Chikkalawar',
                                    mobile:'9063033777'
                                }

                            ]
                        },

                    ]
                }
            },
            {
                name: "Mr And Miss Elan 2021",
                details:
                    "Do you think you have the charm, confidence and talent to stand triumphant with all the attention ? Elan & nvision gives you a platform to make your way to name and fame.",
                photo: One,
                btnVisibilty:[true,true],
                submit:'https://forms.gle/eXjUme26erCmTM1f9',
                modal:{
                    name:'Mr And Miss Elan 2021',
                    link:'https://www.airmeet.com/e/9aa59c20-823e-11eb-8852-cd2c54167cf2',
                    data:[
                        {
                            name:'Rules and Regulations',
                            type:'list',
                            content:[
                                'This event is exclusively for IITH students\n' ,
                                'Round 1 :  \n' ,
                                'The selected entries from Round 1 will be notified via email and will be promoted to Round 2.   \n' ,
                                'Round 2 : 1) Interview round with our esteemed Judge. \n' ,
                                '\t       2)  A 30 sec video showcasing your talent and creativity. \n' ,
                                'In Round 2, the interview part and video part will have 70 and 30 percent weight respectively.\n' ,
                                'The decision of the judges and the organizers is final and abiding.\n' ,
                                'The winners will be announced on our instagram competitions page - @elan_nvision.competitions. \n',
                            ]
                        },
                        {
                            name:'Timeline',
                            type:'list',
                            content:[

                                'Submission deadline for Round 1 : 6th March 11:59 pm\n' ,
                                'Video submission deadline for Round 2 : 13th March 11:59 pm\n' ,
                                'Interview for Round 2 : 12th March\n' ,
                                'Announcement of winners : 14th March\n' ,
                                'The timings for the interview round will be informed personally to the selected participants via email.\n'
                            ]
                        },
                        {
                            name:'Judgement Criteria',
                            type:'list',
                            content:[
                                'Talent\n' ,
                                'Creativity\n' ,
                                'Personality\n' ,
                                'Confidence\n'
                            ]
                        },
                        {
                            name:'Prizes',
                            type:'text',
                            content: 'Exciting vouchers and goodies'

                        },
                    ]
                }
            },
            {
                name: "BEST PICKUP LINE",
                details:
                    "Is the description even needed? Come on…\n" +
                    "Just bring out the cheesiness and flirtiness within you!\n",
                photo: Two,
                btnVisibilty:[true,true],
                submit:'https://forms.gle/ybcqd6UucNvNgviU7',
                modal:{
                    name:'BEST PICKUP LINE',
                    data:[
                        {
                            name:'Rules and Regulations',
                            type:'list',
                            content:[
                                'Plagiarism is strictly prohibited\n' ,
                                'Only 1 entry is allowed per participant\n',
                                'Maximum 3 entries are allowed per participant.',
                                'The top 5 submissions will be shared on our instagram competitions page - @elan_nvision.competitions.\n',
                                'The top 3 submissions will receive prizes. \n' ,
                                'The decision of the judges and the organizers is final and abiding.\n'
                            ]
                        },
                        {
                            name:'Timeline ',
                            type:'list',
                            content:[

                                'Submission deadline : 8th March, 11:59pm\n',
                                'Announcement of winners : 11th March\n'
                            ]
                        },
                        {
                            name:'Prizes',
                            type:'text',
                            content:'Exciting vouchers and goodies'
                        },
                    ]
                }
            },
            {
                name: "CHESS",
                details:
                    "It is a war over the board. \n" +
                    "Elan & nvision invites you to join this war of brains, focus and skills.\n",
                photo: Three,
                btnVisibilty:[true,true],
                submit:'https://forms.gle/Y2V8ZbMsfX64Jfgg8',
                submitAlt:'REGISTER',
                modal:{
                    name:'Chess',
                    data:[
                        {
                            name:'Format ',
                            type:'list',
                            content:[
                                'Platform : Lichess\n' ,
                                'Tournament duration : 90 min\n' ,
                                'Time Control : 2-3 min\n' ,
                                'Participants will not be divided into pools. One single tournament will be conducted. \n' ,
                                'No berserk is allowed\n' ,
                                'Tournament will not be rated.\n'
                            ]
                        },
                        {
                            name:'Rules and regulations',
                            type:'list',
                            content:[
                                'Any player using unfair means will be disqualified.\n' ,
                                'Players will need to join a discord server for further updates. \n' ,
                                'Players need to play on the same lichess account that they have registered. Otherwise, they will not be eligible for prizes. \n' ,
                                'Sandbagging will not be tolerated.\n' ,
                                'In case of any discrepancy, decisions taken by the organizers will be final and abiding. \n' ,
                                'The winners will be given a shout out on our instagram competitions page - @elan_nvision.competitions. \n',
                            ]
                        },
                        {
                            name:'Timeline ',
                            type:'list',
                            content:[

                                'Registration deadline : 6th March\n' ,
                                'Date and time :  6:00pm to 8:00pm on  13th March\n' ,
                                'Rest of the timings will be shared on discord.\n',
                            ]
                        },
                        {
                            name:'Prizes',
                            type:'text',
                            content:'Prize pool of INR 2500 '
                        },
                    ]
                }
            },
            {
                name: "Valorant",
                details:
                    "Love the satisfying feeling of that one tap or the knife.We bring to you an open Valorant tournament conducted in association with fanclash where you can pull out the Aim god in you.",
                photo: Four,
                btnVisibilty:[true,true],
                submit:'https://fanclashapp.page.link/ELAN2021',
                submitAlt:'REGISTER',
                modal:{
                    name:'Valorant',
                    link:'https://www.airmeet.com/e/87219e50-823f-11eb-a42d-f98f1582ce5d',
                    data:[
                        {
                            name:'Rules',
                            type:'list',
                            content:[
                                'You have to participate in squads of 5.\n' ,
                                'Registration will be done on the fanclash app using the code:\n',
                                'Link: https://fanclashapp.page.link/ELAN2021 \n',
                                'Use the Registration Code "IITH21"',
                                'All the match/ game rules will be mentioned in the fanclash app.\n',
                                ' Registrations will not be accepted after the end date.\n',
                            ]
                        },
                        {
                            name:'Timeline',
                            type:'list',
                            content:[
                                'Registration-25th Feb -  5th March\n',
                                'Matches start from- 8th March\n',
                            ]
                        },
                        {
                            name:'Prizes',
                            type:'list',
                            content:[
                                'Prize pool of Rs 10,000;\n',
                                'Winner gets Rs 6000 and Runners up gets Rs 4000\n'
                            ]
                        },
                    ]
                }
            },//29
            {
                name: "Meme Making",
                details:
                    "The age of meme’s has arrived and meme making has become an art form.The meme making competition of Elan & Nvision is here to bring out the comic in you and release the beast.",
                photo: Five,
                btnVisibilty:[true,true],
                submit:'https://forms.gle/NRCd5zf6pFmcWggXA',
                modal:{
                    name:'Meme Making',
                    data:[
                        {
                            name:'Rules and Regulations',
                            type:'list',
                            content:[
                                'You can send a maximum of 1 entry via the google form.\n' ,
                                'The topic is CHILDHOOD.\n' ,
                                'The meme should strictly adhere to the topic mentioned.\n' ,
                                'The best 5 among the sent in responses will be considered and posted on our instagram page.\n' ,
                                'The respective participants that are able to bring the maximum number of likes for their post will be considered the winner.\n'
                            ]
                        },
                        {
                            name:'Timeline ',
                            type:'list',
                            content:[
                                'Taking entries from 1st March -8th March\n' ,
                                'Shortlisting and voting for the memes starting from 10th -13th March\n',
                            ]
                        },
                        {
                            name:'Prizes',
                            type:'text',
                            content:'Gift vouchers and goodies'
                        },
                    ]
                }
            },
            {
                name: "Quiz Hub",
                details:
                    "This is a group quiz competition where the questions are fun and the answers even funnier. This is not for those faint hearted ones as the answers are sure to question your existence.",
                photo: Six,
                btnVisibilty:[true,true],
                submit:'https://forms.gle/7LWXCbUZkFJ39Nky6',
                submitAlt:'REGISTER',
                modal:{
                    name:'Quiz Hub',
                    link:'https://www.airmeet.com/e/005dbb40-8241-11eb-9b87-61b609dfbef7',
                    data:[
                        {
                            name:'Rules and Regulations',
                            type:'list',
                            content:[
                                'You have to participate in teams of four.\n' ,
                                'The top 4 teams will be considered for the second round ,the ranking’s will be decided\n' +
                                'based on the number of questions answered correctly and how fast you answered based\n' +
                                'on your time of submission.\n' ,
                                'The quizzes will be sent to your mail at sharp 5pm on March 7th\n' ,
                                'The second round will have many variations from buzzer beaters, round the table, and\n' +
                                'randomised while using various platforms like discord etc.\n' ,
                                'The points of the teams will be mentioned aοer each round and the positions of the\n' +
                                'respective teams.\n' ,
                                'Answering when it’s not your turn will not be allowed.\n' ,
                                'Each question has a time limit to be answered.\n' ,
                                'Googling for the answer is not accepted.\n' ,
                                'The quiz will be streamed and the participants will have to display their face for some of\n' +
                                'the questions',
                            ]
                        },
                        {
                            name:'Timeline ',
                            type:'list',
                            content:[
                                'Registrations : 3rd -8th March\n' ,
                                'Date of quiz:\n'
                            ]
                        },
                        {
                            name:'Prizes',
                            type:'text',
                            content:' Gift vouchers and goodies\n'
                        },
                    ]
                }
            },
            {
                name:'Comedy Night with Zakir Khan',
                photo:ZakirKhan,
                submit:'https://forms.gle/MbYYoGoJpbJdngcs6',
                details:'We are here with one of the most celebrated comedian - Zakir Khan . A writer by profession, this \'Confused Desi\' serves his take on modern India, with a hard-to-resist style of humour that will have you nodding your heads and clapping as you will relate to everything he says. \n' +
                    '\n' +
                    'Gear up to cherish the moments of laughter and joy. Don\'t miss his performance on Saturday March 13th 6:00 PM.',
                modal:{
                    name:'Comedy Night with Zakir Khan',
                    data:[
                        {
                            name:'Details',
                            type:'text',
                            content:'We are here with one of the most celebrated comedian - Zakir Khan . A writer by profession, this \'Confused Desi\' serves his take on modern India, with a hard-to-resist style of humour that will have you nodding your heads and clapping as you will relate to everything he says. \n' +
                                '\n' +
                                'Gear up to cherish the moments of laughter and joy. Don\'t miss his performance on Saturday March 13th 6:00 PM.'
                        },

                    ]
                }

            },
            {
                name:'Suhani Shah Show',
                photo:SuhaniShah,
                submit:null,
                details:'Do you want to get awestruck by wonderful illusions and mentalism ??\n' +
                    '\n' +
                    'We gladly present you the only female Mentalist, Magician and Illusionist in India - Suhani Shah . A professional hypnotherapist who started her career as a Magician just at an age of 7 ! Suhani Shah has performed so many shows and was invited to several TED Talks as well.\n' +
                    '\n' +
                    'Get ready to witness an amazing performance and enjoy the moments of magic and illusions on March 12th 6 PM IST.',
                modal:{
                    name:'Suhani Shah Show',
                    data:[
                        {
                            name:'Details',
                            type:'text',
                            content:'Do you want to get awestruck by wonderful illusions and mentalism ??\n' +
                                '\n' +
                                'We gladly present you the only female Mentalist, Magician and Illusionist in India - Suhani Shah . A professional hypnotherapist who started her career as a Magician just at an age of 7 ! Suhani Shah has performed so many shows and was invited to several TED Talks as well.\n' +
                                '\n' +
                                'Get ready to witness an amazing performance and enjoy the moments of magic and illusions on March 12th 6 PM IST.'
                        },

                    ]
                }

            },
            {
                name:'Talk Show with Shriya Pilgaonkar',
                photo:Shriya,
                submit:null,
                details:'Elan & ηVision 2021 in association with Clustera are delighted to present to you on the 12th of March 7:30 PM IST, the beautiful actress - Shriya Pilgaonkar. Catch her up while talking about her career and the ups and downs of her wonderful journey.',
                modal:{
                    name:'Talk Show with Shriya Pilgaonkar',
                    data:[
                        {
                            name:'Details',
                            type:'text',
                            content:'Elan & ηVision 2021 in association with Clustera are delighted to present to you on the 12th of March 7:30 PM IST, the beautiful actress - Shriya Pilgaonkar. Catch her up while talking about her career and the ups and downs of her wonderful journey.'
                        },

                    ]
                }
            },//34
            {
                name:'Inaugaration Ceremony',
                submit:null,
                link:'https://www.airmeet.com/e/2c0c01f0-8185-11eb-92df-677d899a473c',
                modal:{
                    name:'Inaugaration Ceremony',
                    link:'https://www.airmeet.com/e/2c0c01f0-8185-11eb-92df-677d899a473c',
                    data:[
                        {
                            name:'Details',
                            type:'text',
                            content:'The inaugural ceremony of the 12th edition of IIT Hyderabad’s annual techno cultural fest, Elan & nVision, graced with the presence of our honorable Director Prof. BS murty, Dean of Students, Prof Rajalakshmi, Our Faculty Incharge for the fest, Dr Avinash Eranki, and our chief guest from Larsen and Toubro Limited, Mr. Siddharth Gupta, Head of Sales and Tendering and Mr Mayank from Corporate HR division \n' +
                                'This ceremony will kick off the nostalgic ride “Fables of a Moppet” from 11th-14th March .'
                        }
                    ]
                }
            },
            {
                name:'Indie Rock - Naalayak',
                photo:Nalayak,
                submit:null,
                details:'Elan & ηVision 2021 and Campus Events Private Limited are delighted to present to you on the 14th of March 6 PM IST, Naalayak.\n' +
                    '\n' +
                    'Defined by its enchanting stage persona, Naalayak , is an emerging, first of its kind, independent rock band from Chandigarh. Applauded for the crazy acts and stupefying live performances, Naalayak’s music gently teases the bizarreness of the “Modern Society”.',
                modal:{
                    name:'Indie Rock - Naalayak',

                    data:[
                        {
                            name:'Details',
                            type:'text',
                            content:'Elan & ηVision 2021 and Campus Events Private Limited are delighted to present to you on the 14th of March 6 PM IST, Naalayak.\n' +
                                '\n' +
                                'Defined by its enchanting stage persona, Naalayak , is an emerging, first of its kind, independent rock band from Chandigarh. Applauded for the crazy acts and stupefying live performances, Naalayak’s music gently teases the bizarreness of the “Modern Society”.'
                        }
                    ]
                }
            },
            {
                name:'Social Cause - Insta Live',
                photo:null,
                submit:null,
                platformIndependent: true,
                details:'Reshma Valliappan, also known as Val resh, is an artist- activist, for a number of issues related to mental health, disability, sexuality and human rights. She is also the founder-director of The Red Door that has been using creativity to redefine mental ill health and other disorders since 2011. She is also the protagonist of an award winning documentary "A drop of sunshine" based on her living with schizophrenia without medications. She will be talking about "understanding mental health through Creativity"',
                modal:{
                    name:'Social Cause - Insta Live',

                    data:[
                        {
                            name:'Details',
                            type:'text',
                            content:'Reshma Valliappan, also known as Val resh, is an artist- activist, for a number of issues related to mental health, disability, sexuality and human rights. She is also the founder-director of The Red Door that has been using creativity to redefine mental ill health and other disorders since 2011. She is also the protagonist of an award winning documentary "A drop of sunshine" based on her living with schizophrenia without medications. She will be talking about "understanding mental health through Creativity"'
                        }
                    ]
                }
            },
            {
                name:'Honeywell Webinar',
                photo:[HB1, HB2],
                submit:null,
                platformIndependent: true,
                details:'Webinar by Experts from Honeywell',
                modal:{
                    name:'Honeywell Webinar',

                    data:[
                        {
                            name:'Details',
                            type:'text',
                            content:'Webinar by Experts from Honeywell'
                        }
                    ]
                }
            },
            {
                name:'Honeywell Webinar',
                photo:[HB3,HB4],
                submit:null,
                platformIndependent: true,
                details:'Webinar by Experts from Honeywell',
                modal:{
                    name:'Honeywell Webinar',

                    data:[
                        {
                            name:'Details',
                            type:'text',
                            content:'Webinar by Experts from Honeywell'
                        }
                    ]
                }
            },//39
            {
                name:'Yocket Webinar',
                photo:Yocket,
                submit:null,
                platformIndependent: true,
                details:'Reshma Valliappan, also known as Val resh, is an artist- activist, for a number of issues related to mental health, disability, sexuality and human rights. She is also the founder-director of The Red Door that has been using creativity to redefine mental ill health and other disorders since 2011. She is also the protagonist of an award winning documentary "A drop of sunshine" based on her living with schizophrenia without medications. She will be talking about "understanding mental health through Creativity"',
                modal:{
                    name:'Yocket Webinar',

                    data:[
                        // {
                        //     name:'Details',
                        //     type:'text',
                        //     content:'Reshma Valliappan, also known as Val resh, is an artist- activist, for a number of issues related to mental health, disability, sexuality and human rights. She is also the founder-director of The Red Door that has been using creativity to redefine mental ill health and other disorders since 2011. She is also the protagonist of an award winning documentary "A drop of sunshine" based on her living with schizophrenia without medications. She will be talking about "understanding mental health through Creativity"'
                        // }
                    ]
                }
            },
            {
                name:'Yocket Webinar',
                photo:Yocket,
                submit:null,
                platformIndependent: true,
                details:'Reshma Valliappan, also known as Val resh, is an artist- activist, for a number of issues related to mental health, disability, sexuality and human rights. She is also the founder-director of The Red Door that has been using creativity to redefine mental ill health and other disorders since 2011. She is also the protagonist of an award winning documentary "A drop of sunshine" based on her living with schizophrenia without medications. She will be talking about "understanding mental health through Creativity"',
                modal:{
                    name:'Yocket Webinar',

                    data:[
                        // {
                        //     name:'Details',
                        //     type:'text',
                        //     content:'Reshma Valliappan, also known as Val resh, is an artist- activist, for a number of issues related to mental health, disability, sexuality and human rights. She is also the founder-director of The Red Door that has been using creativity to redefine mental ill health and other disorders since 2011. She is also the protagonist of an award winning documentary "A drop of sunshine" based on her living with schizophrenia without medications. She will be talking about "understanding mental health through Creativity"'
                        // }
                    ]
                }
            },
            {
                name:'Yocket Webinar',
                photo:Yocket,
                submit:null,
                platformIndependent: true,
                details:'Reshma Valliappan, also known as Val resh, is an artist- activist, for a number of issues related to mental health, disability, sexuality and human rights. She is also the founder-director of The Red Door that has been using creativity to redefine mental ill health and other disorders since 2011. She is also the protagonist of an award winning documentary "A drop of sunshine" based on her living with schizophrenia without medications. She will be talking about "understanding mental health through Creativity"',
                modal:{
                    name:'Yocket Webinar',

                    data:[
                        // {
                        //     name:'Details',
                        //     type:'text',
                        //     content:'Reshma Valliappan, also known as Val resh, is an artist- activist, for a number of issues related to mental health, disability, sexuality and human rights. She is also the founder-director of The Red Door that has been using creativity to redefine mental ill health and other disorders since 2011. She is also the protagonist of an award winning documentary "A drop of sunshine" based on her living with schizophrenia without medications. She will be talking about "understanding mental health through Creativity"'
                        // }
                    ]
                }
            },
        ]
    }
    render() {
        // const imgElCurrent = imgRef.current;
        //
        // if (imgElCurrent) {
        //     imgElCurrent.addEventListener("load", onImageLoaded);
        //     return () => imgElCurrent.removeEventListener("load", onImageLoaded);
        // }
        return (

            <div className='event-detail'
                style={{display:this.props.match.params.id != -1 ? 'block' : 'flex'}} >
                {/*{console.log(this.props.match.params.id,this.data[this.props.match.params.id].modal)}*/}
                {/*<div className={'headline'}>*/}
                {/*    <div/>*/}
                {/*    <h2 className={'item-name'}>{name}</h2>*/}
                {/*    /!*<Image src={sp1} className={'sp1'}/>*!/*/}
                {/*    /!*<Image src={sp2} className={'sp2'}/>*!/*/}
                {/*</div>*/}

                {
                    this.props.match.params.id != -1 ? (<>
                        {
                            this.data[this.props.match.params.id].photo ?
                                ( Array.isArray(this.data[this.props.match.params.id].photo) ?


                                    this.data[this.props.match.params.id].photo.map(item=>
                                            <Image
                                                //onLoad={onImageLoaded}
                                                src={item}

                                                className={"event-photo"}
                                                //style={{ display: state ? "block" : "none" }}
                                            />
                                        )
                                : (<Image
                                //onLoad={onImageLoaded}
                                src={this.data[this.props.match.params.id].photo}

                                className={"event-photo"}
                                //style={{ display: state ? "block" : "none" }}
                            />)) : null
                        }
                        <h2 className={'item-name'}>{this.data[this.props.match.params.id].modal.name}</h2>
                        {
                            this.data[this.props.match.params.id].platformIndependent ? null : (
                                <a className={'event-link'}  href={this.data[this.props.match.params.id].modal.link || '#'}>WATCH</a>
                            )
                        }

                {this.data[this.props.match.params.id].modal.data.map(item=>{
                    return (<div className={'detail-item'}>
                    <h3>{item.name}</h3>
                {getContent(item.type,item.content)}
                    </div>)
                })}
                    </>) : (
                        <h2 className={'coming-soon-msg'}>
                            Coming Soon
                        </h2>
                    )
                }


            </div>
        );
    }
}

export default EventDetails;